import MDTypography from "components/MDTypography";

const sessionHeader = [
  { Header: "Message Name", accessor: "msgName", align: "left" },
  { Header: "Message Value", accessor: "msgVal", align: "center" },
  {
    Header: "Message Value",
    accessor: "msgValTwo",
    align: "center",
  },
];

const regularHeader = [
  { Header: "Tag", accessor: "tag", align: "left", width: "5%" },
  { Header: "Field Name", accessor: "fieldName", align: "left", width: "15%" },
  { Header: "Comments", accessor: "comments", align: "left" },
];

const vletAlgoSheetHeader = [
  { Header: "Sr.No", accessor: "srno", align: "left", width: "5%" },
  { Header: "Route", accessor: "route", align: "left", width: "15%" },
  { Header: "Tag100", accessor: "tag100", align: "left" },
  { Header: "Tag57", accessor: "tag57", align: "left" },
  { Header: "Tag111", accessor: "tag111", align: "left" },
  { Header: "Tag9002", accessor: "tag9002", align: "left" },
  { Header: "Tag9003", accessor: "tag9003", align: "left" },
  { Header: "Tag9004", accessor: "tag9004", align: "left" },
  { Header: "Tag9005", accessor: "tag9005", align: "left" },
];

let fixApiData = [
  {
    mainHeadingStatic: "Introduction",
    mainGridIdStatic: "introduction",
  },
  {
    mainHeadingStatic: "Overview",
    mainGridIdStatic: "overview",
    mainHeadingDescStatic:
      "Note that this specification is the standard FIX specification to be used for FIX order flow. It is assumed that the reader is familiar with the FIX 4.2 Protocol as described at",
    generalDescWithLinkOne: {
      desc: "Fixtrading.org",
      link: "Fixtrading.org",
    },
  },
  {
    mainHeadingStatic: "Data Type",
    mainGridIdStatic: "data-type",
  },
  {
    subheadingIntro: "Timestamps",
    subheadingIntroId: "timestamps",
    subheadingDesc:
      "All FIX timestamps are GMT as per FIX standard. Counter party is expected to synchronize their clocks with an external time source.",
  },
  {
    subheadingIntro: "Message Format",
    subheadingIntroId: "message-format",
    subheadingDesc:
      "FIX messages are ASCII formatted. The member will be provided with a SenderCompId and optionally a SenderSubId that must be sent on every message. All messages that counter firm receives will have the Sender and Target fields swapped.",
  },
  {
    subheadingIntro: "Sequence Numbers",
    subheadingIntroId: "sequence-numbers",
    subheadingDesc:
      "Sequence numbers, both inbound and outbound, will be reset to 1 each night during the down time. Messages are processed in a sequential order. Message received with sequence lower than the current sequence (other than Sequence Reset – Reset) triggers an immediate logout. Message received with sequence ahead of current sequence (other than a Resend Request) triggers a message recovery via a Resend Request.",
  },
  {
    subheadingIntro: "Fix Engine downtime",
    subheadingIntroId: "fix-engine-downtime",
    subheadingDesc:
      "Please note that our FIX engines will be up at 2:00 a.m. EST, while we will disconnect at 11:00 p.m. EST.",
  },
  {
    subheadingIntro: "Version Compatibility",
    subheadingIntroId: "version-compatibility",
    subheadingDesc: "Gato Systems uses the FIX 4.2 session protocol.",
  },
  {
    mainHeadingStatic: "Supported Messages",
    mainGridIdStatic: "supported-messages",
  },
  // Session Messages
  {
    subheadingIntro: "Session Messages",
    subheadingIntroId: "session-messages",
    sessionTable: {
      columns: [...sessionHeader],
      rows: [
        {
          msgName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Logon
            </MDTypography>
          ),
          msgVal: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              35
            </MDTypography>
          ),
          msgValTwo: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              A
            </MDTypography>
          ),
        },
        {
          msgName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Heartbeat
            </MDTypography>
          ),
          msgVal: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              35
            </MDTypography>
          ),
          msgValTwo: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              0
            </MDTypography>
          ),
        },
        {
          msgName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Test Request
            </MDTypography>
          ),
          msgVal: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              35
            </MDTypography>
          ),
          msgValTwo: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              1
            </MDTypography>
          ),
        },
        {
          msgName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Resend Request
            </MDTypography>
          ),
          msgVal: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              35
            </MDTypography>
          ),
          msgValTwo: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              2
            </MDTypography>
          ),
        },
        {
          msgName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Reject
            </MDTypography>
          ),
          msgVal: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              35
            </MDTypography>
          ),
          msgValTwo: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              3
            </MDTypography>
          ),
        },
        {
          msgName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Sequence Reset
            </MDTypography>
          ),
          msgVal: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              35
            </MDTypography>
          ),
          msgValTwo: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              4
            </MDTypography>
          ),
        },
        {
          msgName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Logout
            </MDTypography>
          ),
          msgVal: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              35
            </MDTypography>
          ),
          msgValTwo: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              5
            </MDTypography>
          ),
        },
      ],
    },
    subheadingTableDescBottom:
      "All messages must have the valid connectivity information as agreed before connecting to our FIX engine. The default heartbeat interval is 30 seconds. However, the valid values are between 10-60 seconds.",
  },
  // Message Header
  {
    subheadingIntro: "Message Header",
    subheadingIntroId: "message-header",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              8
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              BeginString<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies beginning of new message and protocol version. Always
              first field in message. (Always unencrypted)
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              BodyLength<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Message length, in bytes, forward to the CheckSum <10> field.
Always second field in message. (Always unencrypted)`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              34
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MsgSeqNum<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Integer message sequence number.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              35
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MsgType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Defines Message type.
              <br /> Always third field in message. (Always unencrypted)
              <br /> Valid values:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>A = Logon</li>
                <li>0 = Heartbeat</li>
                <li>1 = Test Request</li>
                <li>2 = Resend Request </li>
                <li>3 = Reject </li>
                <li>4 = Sequence Reset</li>
                <li>5 = Logout</li>
                <li>D = Order – Single</li>
                <li>F = Order Cancel Request</li>
                <li>G = Order Cancel/Replace Request</li>
                <li>8 = Execution Report</li>
                <li>9 = Order Cancel Reject</li>
                <li>AB = New Order Multileg</li>
                <li>AC = Multileg Order Cancel/Replace</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              43
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              PossDupFlag
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates possible retransmission of message with this sequence
              number. Default value is "N"
              <br />
              Valid values:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>Y = Possible duplicate</li>
                <li>N = Original transmission</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              49
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SenderCompID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Assigned value used to identify firm sending message. (Always
              unencrypted)
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              50
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SenderSubID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Assigned value used to identify specific message originator.
              (Desk, trader, etc.)
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              52
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SendingTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of message transmission (Always expressed in Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              56
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TargetCompID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Assigned value used to identify firm receiving message. (Always
              unencrypted).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              57
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TargetSubID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Assigned value used to identify specific individual or unit
              intended to receive message.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              97
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              PossResend
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates that message may contain information that has been sent
              under another sequence number. <br />
              Valid Values:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>Y = Possible resend</li>
                <li> N = Original transmission</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              115
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OnBehalfOfCompID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Client's MPID used to identify firm originating message if the
              message was delivered by a third party.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              116
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OnBehalfOfSubID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Assigned value used to identify specific message originator (i.e.
              trader) if the message was delivered by a third party.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              122
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigSendingTime
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Original time of message transmission always expressed in UTC
              (Universal Time Coordinated, also known as 'GMT') when
              transmitting orders as the result of a resend request.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              128
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              DeliverToCompID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Assigned value used to identify the firm targeted to receive the
              message if the message is delivered by a third party.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              129
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              DeliverToSubID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Assigned value used to identify specific message recipient (i.e.
              trader) if the message is delivered by a third party.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              142
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SenderLocationID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Assigned value used to identify specific message originator's
              location (i.e., geographic location and/or desk, trader).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              143
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TargetLocationID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Assigned value used to identify specific message destination's
              location (i.e., geographic location and/or desk, trader).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              145
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              DeliverToLocationID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Assigned value used to identify specific message recipient's
              location (i.e., geographic location and/or desk, trader) if the
              message was delivered by a third party.
            </MDTypography>
          ),
        },
      ],
    },
  },
  // Message Trailer
  {
    subheadingIntro: "Message Trailer",
    subheadingIntroId: "message-trailer",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              10
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Checksum<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              3-byte simple checksum. Always represented as 3 ASCII characters
            </MDTypography>
          ),
        },
      ],
    },
  },
  // Logon Message (35=A)
  {
    subheadingIntro: "Logon Message (35=A)",
    subheadingIntroId: "logon-message-35-A",
    subheadingDesc:
      "Logon message must be the first message to exchange with FIX interface. EncryptMethod must be 0.",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              98
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              EncryptMethod
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Method of encryption. <br />
              Valid values:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = None / other</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              108
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HeartBtInt<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Heartbeat <35=0> interval in seconds. A heartbeat interval of 30
seconds is suggested.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              141
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ResetSeqNumFlag
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates that both sides of the FIX session should reset sequence
              numbers.
              <br />
              Valid values:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>Y = Yes, reset sequence numbers</li>
                <li>N = No</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },
  //  Heartbeat (35=0)
  {
    subheadingIntro: "Heartbeat (35=0)",
    subheadingIntroId: "heartbeat-35-0",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              112
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TestReqID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Identifier included in Test Request <35=1> message to be returned in
resulting Heartbeat <35=0>.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //  Test Request (35=1)
  {
    subheadingIntro: "Test Request (35=1)",
    subheadingIntroId: "test-request-35-1",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              112
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TestReqID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Identifier included in Test Request <35=1> message to be returned in
resulting Heartbeat <35=0>`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //  Resend Request (35=2)
  {
    subheadingIntro: "Resend Request (35=2)",
    subheadingIntroId: "resend-request-35-2",
    subheadingDesc:
      "In case your session disconnects during the day, we expect a logon with SeqReset flag set to N. In case where SeqReset is set Y, all the messages previously sent will be deleted by the server and you will no longer be able to retrieve lost messages. If you send a logon with seq number 1 any time during the day, it will also reset your FIX session and old messages will be deleted from the cache.",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              7
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              BeginSeqNo<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Message sequence number of first message in range to be resent.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              16
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              EndSeqNo<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Message sequence number of last message in range to be resent. If
request is for a single message BeginSeqNo <7> = EndSeqNo <16>. If
request is for all messages subsequent to a particular message,
EndSeqNo <16> = 0 (representing infinity).`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //  Message Reject (35=3)
  {
    subheadingIntro: "Message Reject (35=3)",
    subheadingIntroId: "message-reject-35-3",
    subheadingDesc: `A Reject message is issued when a message is received but cannot be properly processed because of a session-level rule violation. For example, a Reject message is appropriate if a received message contains invalid basic
      data (for example, MsgType=$) which otherwise passes CheckSum and BodyLength checks. This message
      should be used sparingly – whenever possible, messages should be forwarded to the application level for
      business-level rejections. Rejected messages should be logged and the incoming sequence number
      incremented.
      `,
    subheadingDescTwo: `Note: The receiving application should disregard any message that is garbled, cannot be parsed, or fails a data
      integrity check. Processing of the next valid FIX message will cause detection of a sequence gap and a Resend
      Request will be generated. Logic should be included in the FIX engine to recognize possible infinite resend
      loop, which may occur in this situation.`,
    subheadingDescThree: `Generation and receipt of a Reject message indicates a serious error that may be the result of faulty logic in
      either the sending or receiving application.`,
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              MsgType = 3
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              45
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              RefSeqNum<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Reference message sequence number.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Free format text string. For Reject <35=3> it gives reason for reject.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              371
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              RefTagID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`The tag number of the FIX field being referenced.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              372
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              RefMsgType
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`The MsgType <35> of the FIX message being referenced.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              373
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SessionRejectReason
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Code to identify reason for a session-level Reject <3> message.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //  Sequence Reset (35=4)
  {
    subheadingIntro: "Sequence Reset (35=4)",
    subheadingIntroId: "sequence-reset-35-4",
    subheadingDesc: `The sequence reset message is used by the sending application to reset the incoming sequence number on the
      opposing side. This message has two modes: “Sequence Reset-Gap Fill” when GapFillFlag is ‘Y’ and “Sequence
      Reset-Reset” when GapFillFlag is N or not present. The “Sequence Reset-Reset” mode should ONLY be used to
      recover from a disaster situation which cannot be otherwise recovered via “Gap Fill” mode.`,
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              36
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              NewSeqNo<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              New sequence number
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              123
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              GapFillFlag
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Indicates that the Sequence Reset message is replacing
administrative or application messages which will not be resent.
Valid values: Y Gap Fill message, MsgSeqNum field valid N Sequence
Reset, ignore MsgSeqNum`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //  Logout (35=5)
  {
    subheadingIntro: "Logout (35=5)",
    subheadingIntroId: "logout-35-5",
    subheadingDesc: `The logout message initiates or confirms the termination of a FIX session. Disconnection without the exchange
      of logout messages should be interpreted as an abnormal condition.`,
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              354
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              EncodedTextLen
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Byte length of encoded (non-ASCII characters) EncodedText <355>
field.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              355
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              EncodedText
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Encoded (non-ASCII characters) representation of the Text <58>
field in the encoded format specified via the MessageEncoding
<347> field.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  // Application Message
  {
    subheadingIntro: "Application Message",
    subheadingIntroId: "application-message",
    sessionTable: {
      columns: [...sessionHeader],
      rows: [
        {
          msgName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              New Order Single
            </MDTypography>
          ),
          msgVal: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              35
            </MDTypography>
          ),
          msgValTwo: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              D
            </MDTypography>
          ),
        },
        {
          msgName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Order Cancel/Replace Request
            </MDTypography>
          ),
          msgVal: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              35
            </MDTypography>
          ),
          msgValTwo: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              G
            </MDTypography>
          ),
        },
        {
          msgName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Order Cancel Request
            </MDTypography>
          ),
          msgVal: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              35
            </MDTypography>
          ),
          msgValTwo: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              F
            </MDTypography>
          ),
        },
        {
          msgName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Execution Reports
            </MDTypography>
          ),
          msgVal: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              35
            </MDTypography>
          ),
          msgValTwo: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              8
            </MDTypography>
          ),
        },
        {
          msgName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Order Cancel Reject
            </MDTypography>
          ),
          msgVal: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              35
            </MDTypography>
          ),
          msgValTwo: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              9
            </MDTypography>
          ),
        },
        {
          msgName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              New Order Multileg
            </MDTypography>
          ),
          msgVal: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              35
            </MDTypography>
          ),
          msgValTwo: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              AB
            </MDTypography>
          ),
        },
        {
          msgName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Multileg Order Cancel/Replace
            </MDTypography>
          ),
          msgVal: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              35
            </MDTypography>
          ),
          msgValTwo: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              AC
            </MDTypography>
          ),
        },
        {
          msgName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Allocations
            </MDTypography>
          ),
          msgVal: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              35
            </MDTypography>
          ),
          msgValTwo: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              J
            </MDTypography>
          ),
        },
      ],
    },
  },
  //Equities
  {
    mainHeadingStatic: "Equities",
    mainGridIdStatic: "equities",
  },

  // New Order Single (35=D)
  {
    subheadingIntro: "New Order Single (35=D)",
    subheadingIntroId: "equities-new-order-single-35-d",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Account mnemonic as agreed between broker and institution.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Unique identifier for Order as assigned by the buy-side. Uniqueness
must be guaranteed within a single trading day. Character limit is 40.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              12
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Commission
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Commission. Note if CommType <13> is Percentage, Commission <12>
of 5% should be represented as .05`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              13
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CommType
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Per Unit (implying shares, par, currency, etc.)</li>
                <li> 2 = Percentage </li>
                <li>3 = Absolute (Total monetary amount)</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Currency
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies currency used for price. Absence of this field is
              interpreted as the default for the security.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              18
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecInst
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              <ul>
                Instructions for order handling on exchange trading floor. Valid
                values:
                <li>1 = Not held</li>
                <li>5 = Held</li>
                <li> M = Mid-price peg (Midprice of inside quote)</li>
                <li> N = Non-negotiable</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HandInst<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              <ul>
                Instructions for order handling on Broker trading floor
                <br />
                Valid values:
                <li>
                  1 = Automated execution order, private, no Broker intervention
                </li>
                <li>
                  2 = Automated execution order, public, Broker intervention OK
                </li>
                <li>3 = Manual order, best execution</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Identifies class or source of the SecurityID <48> value. Required if
SecurityID <48> is specified.`}
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = CUSIP</li>
                <li>2 = SEDOL </li>
                <li>3 = QUIK</li>
                <li>4 = ISIN number</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of shares ordered. Only integer values allowed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              40
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Market</li>
                <li>2 = Limit</li>
                <li>3 = Stop</li>
                <li>4 = Stop limit</li>
                <li> P = Pegged</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              44
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Price
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Price per unit of quantity (e.g., per share). Up to 6 decimal
              places supported.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              47
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Rule80A<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Rule80A is also known as OrderCapacity.
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                Valid values:
                <li>A = Agency</li>
                <li> P = Principal</li>
                <li>R = Riskless Principal</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              48
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              CUSIP or other alternate security identifier.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Side of order <br />
              Valid values:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Buy</li>
                <li>2 = Sell</li>
                <li>5 = Sell short</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Ticker symbol.
We do support NASDAQ CMS Split Symbology. See SymbolSfx <65> for
more details.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. (Note: this field does not have a
              specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Specifies how long the order remains in effect.
              <br />
              Valid values: <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Day</li>
                <li>1 = Good till Cancel (GTC)</li>
                <li>2 = At the Opening (OPG)</li>
                <li>3 = Immediate or Cancel (IOC)</li>
                <li>4 = Fill or Kill (FOK)</li>
                <li>5 = Good till Crossing (GTX)</li>
                <li>7 = At the Close</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              63
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SettlmntTyp
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates order settlement period. Absence of this field is
              interpreted as Regular. Regular is defined as the default
              settlement period for the particular security on the exchange of
              execution.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Regular</li>
                <li>1 = Cash</li>
                <li>2 = Next Day</li>
                <li>3 = T+2</li>
                <li>4 = T+3</li>
                <li>5 = T+4</li>
                <li>6 = Future</li>
                <li>7 = When Issued</li>
                <li>8 = Sellers Option</li>
                <li>9 = T+ 5</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              65
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SymbolSfx
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              We follow NASDAQ CMS Suffix symbology.
              {`Send the root prefix in Symbol <55> and CMS suffix in SymbolSfx <65>`}
              <a href="https://www.nasdaqtrader.com/trader.aspx?id=CQSsymbolconvention">
                NasdaqSymbology
              </a>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              99
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              StopPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Stop Price per share. Required on Stop <40=3> and Stop Limit <40=4>
order type only.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Execution destination as defined by institution when order is
              entered.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              109
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClientID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Firm identifier used in third party-transactions.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              110
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MinQty
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Minimum quantity of an order to be executed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              111
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MaxFloor
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Maximum quantity (e.g., number of shares) within an order to be
              shown on the exchange floor at any given time.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              114
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LocateReqd<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              For Sell Short orders, indicates whether Velocity will perform the
              easy to borrow or locate check.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>Y = Requires a locate</li>
                <li>N = No locate required</li>
                <li>
                  If this field is omitted, the default value is Y, Velocity
                  will perform the ETB/Locate check.
                </li>
                <li>{`If set to N, the LocateID <5700> must contain the MPID of the Locate
broker.`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: CS
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              377
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SolicitedFlag
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates whether or not the order was solicited. <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li> Y = Was solcitied</li>
                <li> N = Was not solicited</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5700
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LocateID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies the broker who loaned the stock to settle a short sale.
              Required if 114=N and 54=5
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5737
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LocateOrderID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Required if locate is acquired from Velocity’s Locate System.
              LocateOrderID should contain the Locate Order ID that Velocity’s
              Locate System will provide in return of Locate acquisition.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9133
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LocateFee<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Custom tag for Sell Short Orders.
              <ul style={{ paddingTop: "10px" }}>
                <li>
                  {" "}
                  {`When LocateFee <9133> is populated with a value, Velocity
will provide the same or even better rate for locate acquisition.`}
                </li>
                <li>{` When LocateFee <9133> is NOT populated Velocity will set the
LocateFee on available rate.`}</li>
              </ul>
              Locate fee is calculated on purchase basis.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9416
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              RetailAttestation
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Used to designate “Retail Orders” required by wholesalers and
              ECNs.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  // Order Cancel / Replace Request (35=G)
  {
    subheadingIntro: "Order Cancel / Replace Request (35=G)",
    subheadingIntroId: "equities-order-cancel-replace-request-35-g",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Account mnemonic as agreed between broker and institution.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Unique identifier for Order as assigned by the buy-side. Uniqueness
must be guaranteed within a single trading day. Character limit is 40.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Currency
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              18
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecInst<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HandInst
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of shares ordered. Only integer values allowed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              40
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Market</li>
                <li>2 = Limit</li>
                <li>3 = Stop</li>
                <li>4 = Stop limit</li>
                <li> P = Pegged</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
as assigned by the institution, used to identify the previous order in
cancel and cancel/replace requests.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              44
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Price
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Price per unit of quantity (e.g., per share). Up to 6 decimal
              places supported.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              47
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Rule80A<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              48
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. <br />
              (Note: this field does not have a specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Specifies how long the order remains in effect.
              <br />
              Valid values: <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Day</li>
                <li>1 = Good till Cancel (GTC)</li>
                <li>2 = At the Opening (OPG)</li>
                <li>3 = Immediate or Cancel (IOC)</li>
                <li>4 = Fill or Kill (FOK)</li>
                <li>5 = Good till Crossing (GTX)</li>
                <li>7 = At the Close</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              65
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SymbolSfx
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              99
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              StopPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Stop Price per share. Required on Stop <40=3> and Stop Limit <40=4>
order type only.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              109
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClientID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Firm identifier used in third party-transactions.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              111
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MaxFloor
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Maximum quantity (e.g., number of shares) within an order to be
              shown on the exchange floor at any given time.
              <br />
              Needs to be defined if it was defined in the New Single Order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              114
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LocateReqd
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              For Sell Short orders, indicates whether Velocity will perform the
              easy to borrow or locate check.
              <br />
              Valid Values:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>Y = Requires a locate</li>
                <li>N = No locate required</li>
              </ul>
              If this field is omitted, the default value is Y, Velocity will
              perform the ETB/Locate check.
              {`If set to N, the LocateID <5700> must contain the MPID of the Locate
broker.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Security Type<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: CS
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5700
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LocateID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies the broker who loaned the stock to settle a short sale.
              Required if 114=N and 54=5
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5737
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LocateOrderID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Required if locate is acquired from Velocity’s Locate System.
              LocateOrderID should contain the Locate Order ID that Velocity’s
              Locate System will provide in return of Locate acquisition.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //Order Cancel Request (35=F)
  {
    subheadingIntro: "Order Cancel Request (35=F)",
    subheadingIntroId: "equities-order-cancel-request-35-f",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Account mnemonic as agreed between broker and institution.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Currency
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              18
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecInst<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HandInst
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of shares ordered. Only integer values allowed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
as assigned by the institution, used to identify the previous order in
cancel and cancel/replace requests.
`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              47
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Rule80A<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              48
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. (Note: this field does not have a
              specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              65
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SymbolSfx
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              109
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClientID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Firm identifier used in third party-transactions.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Security Type<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: CS
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //Execution Report (35=8)
  {
    subheadingIntro: "Execution Report (35=8)",
    subheadingIntroId: "equities-execution-report-35-8",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              AvgPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Average price of executions for this order weighed by trade size.
Zero if CumQty <14> is zero.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              14
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CumQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Cumulative quantity of shares executed for this order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              17
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier of execution message. Uniqueness must be
              guaranteed within a single trading day or the life of a multi-day
              order.
              <br />
              {`ExecID <17> is provided for the following OrdStatus <39>`}
              <ul style={{ paddingTop: "10px" }}>
                <li>{`Partially Filled <39=1>`}</li>
                <li>{`Filled <39=2>`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              19
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecRefID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Reference identifier used with Cancel <20=1> and Correct <20=2>
transaction types.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              20
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecTransType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies transaction type
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
                <li>1 = Cancel</li>
                <li>2 = Correct</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HandInst<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              29
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastCapacity
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Broker capacity in order execution
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Agent</li>
                <li>2 = Cross as agent</li>
                <li>3 = Cross as principal</li>
                <li>4 = Principal</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              30
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastMkt
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Market of execution for last fill.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              31
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Price of this fill (zero for non-fills)
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              32
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastShares<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Quantity of shares traded on this fill (zero for non-fills).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of shares ordered. Only integer values allowed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              39
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdStatus
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies current status of order or chain of orders if
              cancel/replaced.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
                <li>1 = Partially filled</li>
                <li>2 = Filled</li>
                <li>3 = Done for day</li>
                <li>4 = Canceled</li>
                <li>5 = Replaced</li>
                <li>6 = Pending Cancel</li>
                <li>8 = Rejected</li>
                <li>A = Pending New</li>
                <li>E = Pending Replace</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              40
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
as assigned by the institution, used to identify the previous order in
cancel and cancel/replace requests.
`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              44
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Price
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              47
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Rule80A <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              48
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. (Note: this field does not have a
              specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              65
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SymbolSfx
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              76
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Exec Broker <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies executing / give-up broker. Standard NASD market-maker
              mnemonic is preferred.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              137
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MiscFeeAmt
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Miscellaneous fee value. Used for specifying ECNs fee.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              150
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecType <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Describes the specific ExecutionReport <35=8>`}
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
                <li>1 = Partial fill</li>
                <li>2 = Fill</li>
                <li>3 = Done for day</li>
                <li>4 = Canceled </li>
                <li>5 = Replaced</li>
                <li>6 = Pending Cancel</li>
                <li>8 = Rejected</li>
                <li>A = Pending New</li>
                <li>E = Pending Replace</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              151
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Leaves Qty <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Quantity open for further execution. LeavesQty <151> = OrderQty
<38> - CumQty <14>
If order is no longer active i.e., the OrdStatus is Canceled <39=4>,
DoneForTheDay <39=3>, or Rejected <39=8>, then LeavesQty <151>
will be 0.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityType <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: CS
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              851
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastLiquidityInd <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicator to identify whether this fill was a result of a
              liquidity provider providing or liquidity taker taking the
              liquidity. Applicable only for OrdStatus (39) of Partial or
              Filled.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Added Liquidity</li>
                <li>2 = Removed Liquidity</li>
                <li>3 = Liquidity Routed Out</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9730
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Liquidity Indicator <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Used by ECNs to pass liquidity billing code.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  // Order Cancel Reject (35=9)
  {
    subheadingIntro: "Order Cancel Reject (35=9)",
    subheadingIntroId: "equities-order-cancel-reject-35-9",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
as assigned by the institution, used to identify the previous order in
cancel and cancel/replace requests.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. (Note: this field does not have a
              specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              102
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CxlRejReason
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Code to identify reason for cancel rejection.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Too late to cancel</li>
                <li>1 = Unknown order</li>
                <li>2 = Broker / Exchange Option</li>
                <li>
                  3 = Order already in Pending Cancel or Pending Replace status
                </li>
                <li>{`6 = Duplicate ClOrdID <11> received`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              434
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CxlRejResponseTo
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`  Identifies the type of request that a CancelReject <9> is in response to.`}
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>{`1 = Order Cancel Request <F>`}</li>
                <li>{`2 = Order Cancel/Replace Request <G>`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  /* Equities Algos (VLET) section commented out
  //Equities Algos (VLET)
  {
    mainHeadingStatic: "Equities Algos (VLET)",
    mainGridIdStatic: "equities-algo-vlet",
    mainHeadingDescStatic:
      "This Section describes Application messages for US Equities. Following Application messages are supported.",
  },

  // New Order Single (35=D)
  {
    subheadingIntro: "New Order Single (35=D)",
    subheadingIntroId: "equities-algo-vlet-new-order-single-35-d",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Account mnemonic as agreed between broker and institution.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Unique identifier for Order as assigned by the buy-side. Uniqueness
must be guaranteed within a single trading day. Character limit is 40.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              12
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Commission
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Commission. Note if CommType <13> is Percentage, Commission <12>
of 5% should be represented as .05`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              13
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CommType
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Per Unit (implying shares, par, currency, etc.)</li>
                <li> 2 = Percentage </li>
                <li>3 = Absolute (Total monetary amount)</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Currency
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies currency used for price. Absence of this field is
              interpreted as the default for the security.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              18
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecInst
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              <ul>
                Instructions for order handling on exchange trading floor. Valid
                values:
                <li>1 = Not held</li>
                <li>5 = Held</li>
                <li> M = Mid-price peg (Midprice of inside quote)</li>
                <li> N = Non-negotiable</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HandInst<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              <ul>
                Instructions for order handling on Broker trading floor
                <br />
                Valid values:
                <li>
                  1 = Automated execution order, private, no Broker intervention
                </li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Identifies class or source of the SecurityID <48> value. Required if
SecurityID <48> is specified.`}
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = CUSIP</li>
                <li>2 = SEDOL </li>
                <li>3 = QUIK</li>
                <li>4 = ISIN number</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of shares ordered. Only integer values allowed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              40
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Market</li>
                <li>2 = Limit</li>
                <li>3 = Stop</li>
                <li>4 = Stop limit</li>
                <li> P = Pegged</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              44
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Price
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Price per unit of quantity (e.g., per share). Up to 6 decimal
              places supported.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              47
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Rule80A<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Rule80A is also known as OrderCapacity.
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                Valid values:
                <li>A = Agency</li>
                <li> P = Principal</li>
                <li>R = Riskless Principal</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              48
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              CUSIP or other alternate security identifier.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Side of order <br />
              Valid values:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Buy</li>
                <li>2 = Sell</li>
                <li>5 = Sell short</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Ticker symbol.
We do support NASDAQ CMS Split Symbology. See SymbolSfx <65> for
more details.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. (Note: this field does not have a
              specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Specifies how long the order remains in effect.
              <br />
              Valid values: <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Day</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              63
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SettlmntTyp
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates order settlement period. Absence of this field is
              interpreted as Regular. Regular is defined as the default
              settlement period for the particular security on the exchange of
              execution.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Regular</li>
                <li>1 = Cash</li>
                <li>2 = Next Day</li>
                <li>3 = T+2</li>
                <li>4 = T+3</li>
                <li>5 = T+4</li>
                <li>6 = Future</li>
                <li>7 = When Issued</li>
                <li>8 = Sellers Option</li>
                <li>9 = T+ 5</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              65
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SymbolSfx
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              We follow NASDAQ CMS Suffix symbology.
              {`Send the root prefix in Symbol <55> and CMS suffix in SymbolSfx <65>`}
              <a href="https://www.nasdaqtrader.com/trader.aspx?id=CQSsymbolconvention">
                NasdaqSymbology
              </a>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              99
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              StopPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Stop Price per share. Required on Stop <40=3> and Stop Limit <40=4>
order type only.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Please refer to VLET Algo Sheet.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              109
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClientID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Firm identifier used in third party-transactions.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              111
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MaxFloor
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Maximum quantity (e.g., number of shares) within an order to be
              shown on the exchange floor at any given time.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              114
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LocateReqd<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              For Sell Short orders, indicates whether Velocity will perform the
              easy to borrow or locate check.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>Y = Requires a locate</li>
                <li>N = No locate required</li>
                <li>
                  If this field is omitted, the default value is Y, Velocity
                  will perform the ETB/Locate check.
                </li>
                <li>{`If set to N, the LocateID <5700> must contain the MPID of the Locate
broker.`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: CS
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              377
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SolicitedFlag
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates whether or not the order was solicited. <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li> Y = Was solcitied</li>
                <li> N = Was not solicited</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5700
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LocateID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies the broker who loaned the stock to settle a short sale.
              Required if 114=N and 54=5
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5737
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LocateOrderID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Required if locate is acquired from Velocity’s Locate System.
              LocateOrderID should contain the Locate Order ID that Velocity’s
              Locate System will provide in return of Locate acquisition.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9002{" "}
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              StartTime
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Custom Tag for Order Start Time expressed in UTC. If not present
              it will default to immediate time.
              <br />
              (Universal Time Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9003
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              EndTime
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Custom Tag for Order End Time expressed in UTC. If not present it
              will default to Market Close time. Must be greater than the market
              open, or Start time if used, and equal to or less than the Market
              Close.
              <br />
              (Universal Time Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9004{" "}
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Target%
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Target Percent of Value.
              <br />
              Valid values:
              <br />0 - 25
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9005
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Urgency
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Urgency to be used. Higher urgency more aggressive.
              <br />
              Valid values:
              <br />1 - 3
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9133
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LocateFee<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Custom tag for Sell Short Orders.
              <ul style={{ paddingTop: "10px" }}>
                <li>
                  {" "}
                  {`When LocateFee <9133> is populated with a value, Velocity
will provide the same or even better rate for locate acquisition.`}
                </li>
                <li>{` When LocateFee <9133> is NOT populated Velocity will set the
LocateFee on available rate.`}</li>
              </ul>
              Locate fee is calculated on purchase basis.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9416
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              RetailAttestation
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Used to designate “Retail Orders” required by wholesalers and
              ECNs.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  // Order Cancel / Replace Request (35=G)
  {
    subheadingIntro: "Order Cancel / Replace Request (35=G)",
    subheadingIntroId: "equities-algo-vlet-order-cancel-replace-request-35-g",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Account mnemonic as agreed between broker and institution.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Unique identifier for Order as assigned by the buy-side. Uniqueness
must be guaranteed within a single trading day. Character limit is 40.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Currency
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              18
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecInst<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HandInst
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of shares ordered. Only integer values allowed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              40
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Market</li>
                <li>2 = Limit</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
as assigned by the institution, used to identify the previous order in
cancel and cancel/replace requests.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              44
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Price
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Price per unit of quantity (e.g., per share). Up to 6 decimal
              places supported.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              47
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Rule80A<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              48
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. <br />
              (Note: this field does not have a specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              65
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SymbolSfx
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              109
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClientID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Firm identifier used in third party-transactions.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              111
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MaxFloor
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Maximum quantity (e.g., number of shares) within an order to be
              shown on the exchange floor at any given time.
              <br />
              Needs to be defined if it was defined in the New Single Order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              114
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LocateReqd
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              For Sell Short orders, indicates whether Velocity will perform the
              easy to borrow or locate check.
              <br />
              Valid Values:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>Y = Requires a locate</li>
                <li>N = No locate required</li>
              </ul>
              If this field is omitted, the default value is Y, Velocity will
              perform the ETB/Locate check.
              {`If set to N, the LocateID <5700> must contain the MPID of the Locate
broker.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Security Type<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: CS
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5700
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LocateID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies the broker who loaned the stock to settle a short sale.
              Required if 114=N and 54=5
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5737
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LocateOrderID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Required if locate is acquired from Velocity’s Locate System.
              LocateOrderID should contain the Locate Order ID that Velocity’s
              Locate System will provide in return of Locate acquisition.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9002{" "}
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              StartTime
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Custom Tag for Order Start Time expressed in UTC. If not present
              it will default to immediate time.
              <br />
              (Universal Time Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9003
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              EndTime
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Custom Tag for Order End Time expressed in UTC. If not present it
              will default to Market Close time. Must be greater than the market
              open, or Start time if used, and equal to or less than the Market
              Close.
              <br />
              (Universal Time Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9004{" "}
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Target%
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Target Percent of Value.
              <br />
              Valid values:
              <br />0 - 25
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9005
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Urgency
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Urgency to be used. Higher urgency more aggressive.
              <br />
              Valid values:
              <br />1 - 3
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //Order Cancel Request (35=F)
  {
    subheadingIntro: "Order Cancel Request (35=F)",
    subheadingIntroId: "equities-algo-vlet-order-cancel-request-35-f",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Account mnemonic as agreed between broker and institution.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Currency
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              18
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecInst<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HandInst
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of shares ordered. Only integer values allowed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
as assigned by the institution, used to identify the previous order in
cancel and cancel/replace requests.
`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              47
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Rule80A<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              48
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. (Note: this field does not have a
              specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              65
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SymbolSfx
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              109
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClientID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Firm identifier used in third party-transactions.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Security Type<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: CS
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //Execution Report (35=8)
  {
    subheadingIntro: "Execution Report (35=8)",
    subheadingIntroId: "equities-algo-vlet-execution-report-35-8",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              AvgPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Average price of executions for this order weighed by trade size.
Zero if CumQty <14> is zero.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              14
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CumQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Cumulative quantity of shares executed for this order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              17
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier of execution message. Uniqueness must be
              guaranteed within a single trading day or the life of a multi-day
              order.
              <br />
              {`ExecID <17> is provided for the following OrdStatus <39>`}
              <ul style={{ paddingTop: "10px" }}>
                <li>{`Partially Filled <39=1>`}</li>
                <li>{`Filled <39=2>`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              19
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecRefID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Reference identifier used with Cancel <20=1> and Correct <20=2>
transaction types.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              20
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecTransType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies transaction type
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
                <li>1 = Cancel</li>
                <li>2 = Correct</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HandInst<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              29
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastCapacity
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Broker capacity in order execution
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Agent</li>
                <li>2 = Cross as agent</li>
                <li>3 = Cross as principal</li>
                <li>4 = Principal</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              30
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastMkt
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Market of execution for last fill.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              31
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Price of this fill (zero for non-fills)
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              32
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastShares<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Quantity of shares traded on this fill (zero for non-fills).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of shares ordered. Only integer values allowed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              39
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdStatus
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies current status of order or chain of orders if
              cancel/replaced.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
                <li>1 = Partially filled</li>
                <li>2 = Filled</li>
                <li>3 = Done for day</li>
                <li>4 = Canceled</li>
                <li>5 = Replaced</li>
                <li>6 = Pending Cancel</li>
                <li>8 = Rejected</li>
                <li>A = Pending New</li>
                <li>E = Pending Replace</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              40
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
as assigned by the institution, used to identify the previous order in
cancel and cancel/replace requests.
`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              44
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Price
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              47
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Rule80A <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              48
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. (Note: this field does not have a
              specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              65
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SymbolSfx
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              76
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Exec Broker <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies executing / give-up broker. Standard NASD market-maker
              mnemonic is preferred.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              137
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MiscFeeAmt
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Miscellaneous fee value. Used for specifying ECNs fee.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              150
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecType <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Describes the specific ExecutionReport <35=8>`}
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
                <li>1 = Partial fill</li>
                <li>2 = Fill</li>
                <li>3 = Done for day</li>
                <li>4 = Canceled </li>
                <li>5 = Replaced</li>
                <li>6 = Pending Cancel</li>
                <li>8 = Rejected</li>
                <li>A = Pending New</li>
                <li>E = Pending Replace</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              151
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Leaves Qty <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Quantity open for further execution. LeavesQty <151> = OrderQty
<38> - CumQty <14>
If order is no longer active i.e., the OrdStatus is Canceled <39=4>,
DoneForTheDay <39=3>, or Rejected <39=8>, then LeavesQty <151>
will be 0.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityType <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: CS
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              851
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastLiquidityInd <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicator to identify whether this fill was a result of a
              liquidity provider providing or liquidity taker taking the
              liquidity. Applicable only for OrdStatus (39) of Partial or
              Filled.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Added Liquidity</li>
                <li>2 = Removed Liquidity</li>
                <li>3 = Liquidity Routed Out</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9730
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Liquidity Indicator <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Used by ECNs to pass liquidity billing code.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  // Order Cancel Reject (35=9)
  {
    subheadingIntro: "Order Cancel Reject (35=9)",
    subheadingIntroId: "equities-algo-vlet-order-cancel-reject-35-9",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
as assigned by the institution, used to identify the previous order in
cancel and cancel/replace requests.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. (Note: this field does not have a
              specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              102
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CxlRejReason
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Code to identify reason for cancel rejection.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Too late to cancel</li>
                <li>1 = Unknown order</li>
                <li>2 = Broker / Exchange Option</li>
                <li>
                  3 = Order already in Pending Cancel or Pending Replace status
                </li>
                <li>{`6 = Duplicate ClOrdID <11> received`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              434
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CxlRejResponseTo
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`  Identifies the type of request that a CancelReject <9> is in response to.`}
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>{`1 = Order Cancel Request <F>`}</li>
                <li>{`2 = Order Cancel/Replace Request <G>`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },
  //VLET Algo Sheet
  {
    mainHeadingStatic: "VLET Algo Sheet",
    mainGridIdStatic: "equities-algo-vlet-vlet-algo-sheet",
  },

  // VLET Algo Sheet
  {
    subheadingIntro: " ",
    subheadingIntroId: " ",
    sessionTable: {
      columns: [...vletAlgoSheetHeader],
      rows: [
        {
          srno: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          route: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OPEN
            </MDTypography>
          ),
          tag100: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              ALGO
            </MDTypography>
          ),
          tag57: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              OPEN
            </MDTypography>
          ),
          tag111: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9002: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9003: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9004: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9005: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          srno: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          route: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CLOSE
            </MDTypography>
          ),
          tag100: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              ALGO
            </MDTypography>
          ),
          tag57: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              CLOSE
            </MDTypography>
          ),
          tag111: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9002: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9003: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9004: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9005: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          srno: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          route: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              IS
            </MDTypography>
          ),
          tag100: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              ALGO
            </MDTypography>
          ),
          tag57: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              IS
            </MDTypography>
          ),
          tag111: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9002: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Start Time in UTC
            </MDTypography>
          ),
          tag9003: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              End Time in UTC
            </MDTypography>
          ),
          tag9004: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9005: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          srno: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          route: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TWAP
            </MDTypography>
          ),
          tag100: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              ALGO
            </MDTypography>
          ),
          tag57: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              TWAP
            </MDTypography>
          ),
          tag111: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9002: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Start Time in UTC
            </MDTypography>
          ),
          tag9003: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              End Time in UTC
            </MDTypography>
          ),
          tag9004: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9005: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          srno: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          route: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              VWAP
            </MDTypography>
          ),
          tag100: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              ALGO
            </MDTypography>
          ),
          tag57: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              VWAP
            </MDTypography>
          ),
          tag111: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9002: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Start Time in UTC
            </MDTypography>
          ),
          tag9003: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              End Time in UTC
            </MDTypography>
          ),
          tag9004: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9005: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          srno: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          route: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              POV
            </MDTypography>
          ),
          tag100: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              ALGO
            </MDTypography>
          ),
          tag57: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              POV
            </MDTypography>
          ),
          tag111: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9002: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Start Time in UTC
            </MDTypography>
          ),
          tag9003: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              End Time in UTC
            </MDTypography>
          ),
          tag9004: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              0 - 25
            </MDTypography>
          ),
          tag9005: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          srno: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              7
            </MDTypography>
          ),
          route: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              VCROSS
            </MDTypography>
          ),
          tag100: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              ALGO
            </MDTypography>
          ),
          tag57: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              VCROSS
            </MDTypography>
          ),
          tag111: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9002: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Start Time in UTC
            </MDTypography>
          ),
          tag9003: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              End Time in UTC
            </MDTypography>
          ),
          tag9004: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9005: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              1 - 3
            </MDTypography>
          ),
        },
        {
          srno: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              8
            </MDTypography>
          ),
          route: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              VOWL
            </MDTypography>
          ),
          tag100: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              ALGO
            </MDTypography>
          ),
          tag57: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              VOWL
            </MDTypography>
          ),
          tag111: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9002: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Start Time in UTC
            </MDTypography>
          ),
          tag9003: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              End Time in UTC
            </MDTypography>
          ),
          tag9004: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9005: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              1 - 3
            </MDTypography>
          ),
        },
        {
          srno: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9
            </MDTypography>
          ),
          route: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              VSTALK
            </MDTypography>
          ),
          tag100: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              ALGO
            </MDTypography>
          ),
          tag57: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              VSTALK
            </MDTypography>
          ),
          tag111: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9002: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Start Time in UTC
            </MDTypography>
          ),
          tag9003: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              End Time in UTC
            </MDTypography>
          ),
          tag9004: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9005: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              1 - 3
            </MDTypography>
          ),
        },
        {
          srno: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              10
            </MDTypography>
          ),
          route: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              VATTACK
            </MDTypography>
          ),
          tag100: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              SOR
            </MDTypography>
          ),
          tag57: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              VATTACK
            </MDTypography>
          ),
          tag111: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9002: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Start Time in UTC
            </MDTypography>
          ),
          tag9003: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              End Time in UTC
            </MDTypography>
          ),
          tag9004: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9005: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              1 - 3
            </MDTypography>
          ),
        },
        {
          srno: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          route: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CAPTURE
            </MDTypography>
          ),
          tag100: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              SOR
            </MDTypography>
          ),
          tag57: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              CAPTURE
            </MDTypography>
          ),
          tag111: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9002: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Start Time in UTC
            </MDTypography>
          ),
          tag9003: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              End Time in UTC
            </MDTypography>
          ),
          tag9004: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9005: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          srno: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              12
            </MDTypography>
          ),
          route: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TORR
            </MDTypography>
          ),
          tag100: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              SOR
            </MDTypography>
          ),
          tag57: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              TORR
            </MDTypography>
          ),
          tag111: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9002: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Start Time in UTC
            </MDTypography>
          ),
          tag9003: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              End Time in UTC
            </MDTypography>
          ),
          tag9004: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9005: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          srno: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              13
            </MDTypography>
          ),
          route: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              VEXT
            </MDTypography>
          ),
          tag100: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              SOR
            </MDTypography>
          ),
          tag57: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              VEXT
            </MDTypography>
          ),
          tag111: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              MaxFloor
            </MDTypography>
          ),
          tag9002: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9003: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9004: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9005: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          srno: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              14
            </MDTypography>
          ),
          route: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              VSOR
            </MDTypography>
          ),
          tag100: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              SOR
            </MDTypography>
          ),
          tag57: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              VSOR
            </MDTypography>
          ),
          tag111: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              MaxFloor
            </MDTypography>
          ),
          tag9002: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9003: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9004: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
          tag9005: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },
  */ // End of Equities Algos (VLET) section

  //Fractions
  {
    mainHeadingStatic: "Fractions",
    mainGridIdStatic: "fractions",
    mainHeadingDescStatic:
      "This Section describes Application messages for US Equities Fractions. Following Application messages are supported.",
  },

  // New Order Single (35=D)
  {
    subheadingIntro: "New Order Single (35=D)",
    subheadingIntroId: "fractions-new-order-single-35-d",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Account mnemonic as agreed between broker and institution.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              12
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Commission
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Commission. Note if CommType <13> is Percentage, Commission <12>
of 5% should be represented as .05`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              13
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CommType
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Per Unit (implying shares, par, currency, etc.)</li>
                <li> 2 = Percentage </li>
                <li>3 = Absolute (Total monetary amount)</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Currency
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies currency used for price. Absence of this field is
              interpreted as the default for the security.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              18
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecInst
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              <ul>
                Instructions for order handling on exchange trading floor.{" "}
                <br />
                Valid values:
                <li>1 = Not held</li>
                <li>5 = Held</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HandInst<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              <ul>
                Instructions for order handling on Broker trading floor. Valid
                values:
                <li>
                  1 = Automated execution order, private, no Broker intervention
                </li>
                <li>
                  2 = Automated execution order, public, Broker intervention OK
                </li>
                <li>3 = Manual order, best execution</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Identifies class or source of the SecurityID <48> value. Required if
  SecurityID <48> is specified.`}
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = CUSIP</li>
                <li>2 = SEDOL </li>
                <li>3 = QUIK</li>
                <li>4 = ISIN number</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of shares ordered in Float Values.
              <br />
              {`Note: If a Notional value is provided in GrossTradeAmt <381> then OrderQty <38> should be equal to 0. `}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              40
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Market</li>
                <li>2 = Limit</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              44
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Price
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Price per unit of quantity (e.g., per share). Up to 6 decimal
              places supported.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              47
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Rule80A<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Rule80A is also known as OrderCapacity.
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                Valid values:
                <li>A = Agency</li>
                <li> P = Principal</li>
                <li>R = Riskless Principal</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              48
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              CUSIP or other alternate security identifier.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Side of order <br />
              Valid values:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Buy</li>
                <li>2 = Sell</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Ticker symbol.
  We do support NASDAQ CMS Split Symbology. See SymbolSfx <65> for
  more details.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string.
              <br />
              (Note: this field does not have a specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Specifies how long the order remains in effect.
              <br />
              Valid values: <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Day</li>
                <li>1 = Good till Cancel (GTC)</li>
                <li>2 = At the Opening (OPG)</li>
                <li>3 = Immediate or Cancel (IOC)</li>
                <li>4 = Fill or Kill (FOK)</li>
                <li>5 = Good till Crossing (GTX)</li>
                <li>7 = At the Close</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              63
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SettlmntTyp
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates order settlement period. Absence of this field is
              interpreted as Regular. Regular is defined as the default
              settlement period for the particular security on the exchange of
              execution.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Regular</li>
                <li>1 = Cash</li>
                <li>2 = Next Day</li>
                <li>3 = T+2</li>
                <li>4 = T+3</li>
                <li>5 = T+4</li>
                <li>6 = Future</li>
                <li>7 = When Issued</li>
                <li>8 = Sellers Option</li>
                <li>9 = T+ 5</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              65
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SymbolSfx
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`We follow NASDAQ CMS Suffix symbology.
  Send the root prefix in Symbol <55> and CMS suffix in SymbolSfx <65>
  For understanding CMS Suffix, please refer to.
  `}
              <a href="https://www.nasdaqtrader.com/trader.aspx?id=CQSsymbolconvention">
                NasdaqSymbology
              </a>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Execution destination as defined by institution when order is
              entered.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              109
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClientID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Firm identifier used in third party-transactions.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              111
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MaxFloor
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Maximum quantity (e.g., number of shares) within an order to be
              shown on the exchange floor at any given time.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: CS
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              377
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SolicitedFlag
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates whether or not the order was solicited. <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li> Y = Was solcitied</li>
                <li> N = Was not solicited</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              381
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              GrossTradeAmt
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Notional value for Fractional orders.
              <br />
              {`Note: If OrderQty <38> is populated with Fractional Quantity it will be
given precedence over GrossTradeAmt <381>`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9416
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              RetailAttestation
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Used to designate “Retail Orders” required by wholesalers and
              ECNs.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //Order Cancel Request (35=F)
  {
    subheadingIntro: "Order Cancel Request (35=F)",
    subheadingIntroId: "fractions-order-cancel-request-35-f",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Account mnemonic as agreed between broker and institution.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Currency
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              18
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecInst<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HandInst
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
as assigned by the institution, used to identify the previous order in
cancel and cancel/replace requests.
`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              47
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Rule80A<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              48
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. <br />
              (Note: this field does not have a specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              65
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SymbolSfx
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              109
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClientID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Firm identifier used in third party-transactions.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Security Type<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: CS
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //Execution Report (35=8)
  {
    subheadingIntro: "Execution Report (35=8)",
    subheadingIntroId: "fractions-execution-report-35-8",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              AvgPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Average price of executions for this order weighed by trade size.
  Zero if CumQty <14> is zero.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              14
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CumQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Cumulative quantity of shares/contracts executed for this order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              17
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier of execution message. Uniqueness must be
              guaranteed within a single trading day or the life of a multi-day
              order.
              <br />
              {`ExecID <17> is provided for the following OrdStatus <39>`}
              <ul style={{ paddingTop: "10px" }}>
                <li>{`Partially Filled <39=1>`}</li>
                <li>{`Filled <39=2>`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              19
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecRefID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Reference identifier used with Cancel <20=1> and Correct <20=2>
  transaction types.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              20
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecTransType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies transaction type
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
                <li>1 = Cancel</li>
                <li>2 = Correct</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HandInst<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              29
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastCapacity
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Broker capacity in order execution
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Agent</li>
                <li>2 = Cross as agent</li>
                <li>3 = Cross as principal</li>
                <li>4 = Principal</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              30
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastMkt
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Market of execution for last fill.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              31
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Price of this fill (zero for non-fills)
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              32
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastShares<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Quantity of shares traded on this fill (zero for non-fills).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side.
              <br /> Uniqueness must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              39
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdStatus<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies current status of order or chain of orders if
              cancel/replaced.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
                <li>1 = Partially filled</li>
                <li>2 = Filled</li>
                <li>3 = Done for day</li>
                <li>4 = Canceled</li>
                <li>6 = Pending Cancel</li>
                <li>8 = Rejected</li>
                <li>A = Pending New</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              40
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
  as assigned by the institution, used to identify the previous order in
  cancel and cancel/replace requests.
  `}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              44
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Price
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              47
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Rule80A <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              48
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. <br />
              (Note: this field does not have a specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              65
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SymbolSfx
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              76
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Exec Broker <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies executing / give-up broker. Standard NASD market-maker
              mnemonic is preferred.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              137
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MiscFeeAmt
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Miscellaneous fee value. Used for specifying ECNs fee.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              150
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecType <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Describes the specific ExecutionReport <35=8>`}
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
                <li>1 = Partial fill</li>
                <li>2 = Fill</li>
                <li>3 = Done for day</li>
                <li>4 = Canceled </li>
                <li>6 = Pending Cancel</li>
                <li>8 = Rejected</li>
                <li>A = Pending New</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              151
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Leaves Qty <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Quantity open for further execution. LeavesQty <151> = OrderQty
  <38> - CumQty <14>`}
              {` If order is no longer active i.e., the OrdStatus is Canceled <39=4>,
  DoneForTheDay <39=3>, or Rejected <39=8>, then LeavesQty <151>
  will be 0.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityType <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: CS
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              851
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastLiquidityInd <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicator to identify whether this fill was a result of a
              liquidity provider providing or liquidity taker taking the
              liquidity. Applicable only for OrdStatus (39) of Partial or
              Filled.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Added Liquidity</li>
                <li>2 = Removed Liquidity</li>
                <li>3 = Liquidity Routed Out</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9730
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Liquidity Indicator <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Used by ECNs to pass liquidity billing code.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  // Order Cancel Reject (35=9)
  {
    subheadingIntro: "Order Cancel Reject (35=9)",
    subheadingIntroId: "fractions-order-cancel-reject-35-9",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
  as assigned by the institution, used to identify the previous order in
  cancel and cancel/replace requests.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. (Note: this field does not have a
              specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              102
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CxlRejReason
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Code to identify reason for cancel rejection.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Too late to cancel</li>
                <li>1 = Unknown order</li>
                <li>2 = Broker / Exchange Option</li>
                <li>
                  3 = Order already in Pending Cancel or Pending Replace status
                </li>
                <li>{`6 = Duplicate ClOrdID <11> received`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              434
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CxlRejResponseTo
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`  Identifies the type of request that a CancelReject <9> is in response to.`}
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>{`1 = Order Cancel Request <F>`}</li>
                <li>{`2 = Order Cancel/Replace Request <G>`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //Options – SingleLeg
  {
    mainHeadingStatic: "Options – SingleLeg",
    mainGridIdStatic: "options–singleleg",
    mainHeadingDescStatic:
      "This Section describes Application messages for US Options – Single Leg. Following Application messages are supported.",
  },

  // New Order Single (35=D)
  {
    subheadingIntro: "New Order Single (35=D)",
    subheadingIntroId: "options–singleleg-new-order-single-35-d",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Account mnemonic as agreed between broker and institution.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Unique identifier for Order as assigned by the buy-side. Uniqueness
must be guaranteed within a single trading day. Character limit is 40.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Currency
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies currency used for price. Absence of this field is
              interpreted as the default for the security.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              18
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecInst
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              <ul>
                Instructions for order handling on exchange trading floor.{" "}
                <br />
                Valid values:
                <li>1 = Not held</li>
                <li>5 = Held</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HandInst<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              <ul>
                Instructions for order handling on Broker trading floor. Valid
                values:
                <li>
                  1 = Automated execution order, private, no Broker intervention
                </li>
                <li>
                  2 = Automated execution order, public, Broker intervention OK
                </li>
                <li>3 = Manual order, best execution</li>
              </ul>
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of Option Contracts ordered. Only integer values allowed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              40
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Market</li>
                <li>2 = Limit</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              44
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Price
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Price per unit of quantity (e.g., per contract). Up to 6 decimal
              places supported.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              47
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Rule80A<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Rule80A is also known as OrderCapacity.
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                Valid values:
                <li>A = Agency</li>
                <li> P = Principal</li>
                <li>R = Riskless Principal</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Side of order <br />
              Valid values:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Buy</li>
                <li>2 = Sell</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              OCC ROOT symbol.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. (Note: this field does not have a
              specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Specifies how long the order remains in effect.
              <br />
              Valid values: <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Day</li>
                <li>1 = Good till Cancel (GTC)</li>
                <li>2 = At the Opening (OPG)</li>
                <li>3 = Immediate or Cancel (IOC)</li>
                <li>4 = Fill or Kill (FOK)</li>
                <li>5 = Good till Crossing (GTX)</li>
                <li>7 = At the Close</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              77
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OpenClose<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates whether the resulting position after a trade should be
              an opening position or closing position. Used for omnibus
              accounting - where accounts are held on a gross basis instead of
              being netted together.
              <br />
              Valid Values:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>O=Open</li>
                <li>C=Close</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Execution destination as defined by institution when order is
              entered.
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              109
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClientID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Firm identifier used in third party-transactions.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityType <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: OPT
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              200
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MaturityMonthYear<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Month and Year of the maturity for SecurityType <167>=OPT.
Required if MaturityDay <205> is specified.
Format: YYYYMM`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              201
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              PutOrCall<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates whether an Option is for a put or call.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Put</li>
                <li> 1 = Call</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              202
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              StrikePrice<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Strike Price for an Option.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              204
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CustomerOrFirm<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Used for options when delivering the order to an execution
              system/exchange to specify if the order is for a customer or the
              firm placing the order itself.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Customer</li>
                <li>1 = Firm</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              205
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MaturityDay<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`  Day of month used in conjunction with MaturityMonthYear <200> to
specify the maturity date for SecurityType <167>=OPT.`}
              <br />
              Valid values:
              <br />
              1-31
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              389
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              DiscretionOffset
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Discretion is implicitly added to bid prices and subtracted from
              offer prices. Order will be displayed at Price but can execute in
              discretionary range.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              439
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClearingFirm<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Firm that will clear trade. Used if different from the executing
              firm.
              <br />
              Default Value: 294
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              440
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClearingAccount<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Supplemental accounting information forwarded to Clearing Firm.
              Required where multiple Clearing Accounts are used for same MPID.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9001
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Actionable ID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Actionable Identifier.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9416
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Retail Attestation
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Used to designate “Retail Orders” required by wholesalers and
              ECNs.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  // Order Cancel / Replace Request (35=G)
  {
    subheadingIntro: "Order Cancel / Replace Request (35=G)",
    subheadingIntroId:
      "options–singleleg-order-cancel-request-replace-request-35-g",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Account mnemonic as agreed between broker and institution.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Unique identifier for Order as assigned by the buy-side. Uniqueness
must be guaranteed within a single trading day. Character limit is 40.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Currency
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies currency used for price. Absence of this field is
              interpreted as the default for the security.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              18
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecInst<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HandInst
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of Option Contracts ordered. Only integer values allowed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              40
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Market</li>
                <li>2 = Limit</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
as assigned by the institution, used to identify the previous order in
cancel and cancel/replace requests.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              44
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Price
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Price per unit of quantity (e.g., per contract). Up to 6 decimal
              places supported.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              47
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Rule80A<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. <br />
              (Note: this field does not have a specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Specifies how long the order remains in effect.
              <br />
              Valid values: <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Day</li>
                <li>1 = Good till Cancel (GTC)</li>
                <li>2 = At the Opening (OPG)</li>
                <li>3 = Immediate or Cancel (IOC)</li>
                <li>4 = Fill or Kill (FOK)</li>
                <li>5 = Good till Crossing (GTX)</li>
                <li>7 = At the Close</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              109
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClientID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Firm identifier used in third party-transactions.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Security Type<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: OPT
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              200
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MaturityMonthYear<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              201
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              PutOrCall<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              202
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              StrikePrice<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              204
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CustomerOrFirm<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              205
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MaturityDay<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              439
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClearingFirm<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              440
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClearingAccount<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9001
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Actionable ID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Actionable Identifier
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9416
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Retail Attestation
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Used to designate “Retail Orders” required by wholesalers and
              ECNs.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //Order Cancel Request (35=F)
  {
    subheadingIntro: "Order Cancel Request (35=F)",
    subheadingIntroId: "options–singleleg-order-cancel-request-35-f",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Account mnemonic as agreed between broker and institution.
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
as assigned by the institution, used to identify the previous order in
cancel and cancel/replace requests.
`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              47
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Rule80A<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. (Note: this field does not have a
              specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Security Type<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: OPT
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              439
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClearingFirm<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              440
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClearingAccount<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9001
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Actionable ID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Actionable Identifier
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //Execution Report (35=8)
  {
    subheadingIntro: "Execution Report (35=8)",
    subheadingIntroId: "options–singleleg-execution-report-35-8",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Account mnemonic as agreed between broker and institution.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              AvgPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Average price of executions for this order weighed by trade size.
Zero if CumQty <14> is zero.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              14
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CumQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Cumulative quantity of shares executed for this order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              17
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier of execution message. Uniqueness must be
              guaranteed within a single trading day or the life of a multi-day
              order.
              <br />
              {`ExecID <17> is provided for the following OrdStatus <39>`}
              <ul style={{ paddingTop: "10px" }}>
                <li>{`Partially Filled <39=1>`}</li>
                <li>{`Filled <39=2>`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              19
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecRefID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Reference identifier used with Cancel <20=1> and Correct <20=2>
transaction types.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              20
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecTransType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies transaction type
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
                <li>1 = Cancel</li>
                <li>2 = Correct</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HandInst<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              29
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastCapacity
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Broker capacity in order execution
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Agent</li>
                <li>2 = Cross as agent</li>
                <li>3 = Cross as principal</li>
                <li>4 = Principal</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              30
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastMkt
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Market of execution for last fill.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              31
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Price of this fill (zero for non-fills)
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              32
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastShares<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Quantity of shares traded on this fill (zero for non-fills).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of shares ordered. Only integer values allowed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              39
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdStatus<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies current status of order or chain of orders if
              cancel/replaced.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
                <li>1 = Partially filled</li>
                <li>2 = Filled</li>
                <li>3 = Done for day</li>
                <li>4 = Canceled</li>
                <li>5 = Replaced</li>
                <li>6 = Pending Cancel</li>
                <li>8 = Rejected</li>
                <li>A = Pending New</li>
                <li>E = Pending Replace</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              40
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
as assigned by the institution, used to identify the previous order in
cancel and cancel/replace requests.
`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              44
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Price
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. (Note: this field does not have a
              specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              76
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Exec Broker <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies executing / give-up broker. Standard NASD market-maker
              mnemonic is preferred.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              77
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OpenClose <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              150
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecType <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Describes the specific ExecutionReport <35=8>`}
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
                <li>1 = Partial fill</li>
                <li>2 = Fill</li>
                <li>3 = Done for day</li>
                <li>4 = Canceled </li>
                <li>5 = Replaced</li>
                <li>6 = Pending Cancel</li>
                <li>8 = Rejected</li>
                <li>A = Pending New</li>
                <li>E = Pending Replace</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              151
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Leaves Qty <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Quantity open for further execution. LeavesQty <151> = OrderQty
<38> - CumQty <14>
If order is no longer active i.e., the OrdStatus is Canceled <39=4>,
DoneForTheDay <39=3>, or Rejected <39=8>, then LeavesQty <151>
will be 0.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityType <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: OPT
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              200
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MaturityMonthYear <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              201
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              PutOrCall <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              202
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              StrikePrice <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              204
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CustomerOrFirm
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              205
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MaturityDay <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              851
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastLiquidityInd <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicator to identify whether this fill was a result of a
              liquidity provider providing or liquidity taker taking the
              liquidity. Applicable only for OrdStatus (39) of Partial or
              Filled.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Added Liquidity</li>
                <li>2 = Removed Liquidity</li>
                <li>3 = Liquidity Routed Out</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              439
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClearingFirm <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              440
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClearingAccount <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9730
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Liquidity Indicator <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Used by ECNs to pass liquidity billing code.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  // Order Cancel Reject (35=9)
  {
    subheadingIntro: "Order Cancel Reject (35=9)",
    subheadingIntroId: "options–singleleg-order-cancel-reject-35-9",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
as assigned by the institution, used to identify the previous order in
cancel and cancel/replace requests.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              102
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CxlRejReason
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Code to identify reason for cancel rejection.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Too late to cancel</li>
                <li>1 = Unknown order</li>
                <li>2 = Broker / Exchange Option</li>
                <li>
                  3 = Order already in Pending Cancel or Pending Replace status
                </li>
                <li>{`6 = Duplicate ClOrdID <11> received`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              434
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CxlRejResponseTo
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`  Identifies the type of request that a CancelReject <9> is in response to.`}
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>{`1 = Order Cancel Request <F>`}</li>
                <li>{`2 = Order Cancel/Replace Request <G>`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //Options – MultiLeg
  {
    mainHeadingStatic: "Options – MultiLeg",
    mainGridIdStatic: "options–multileg",
    mainHeadingDescStatic:
      "This Section describes Application messages for US Options – Multi Leg. Following Application messages are supported.",
  },

  // New Order MultiLeg (35=AB)
  {
    subheadingIntro: "New Order MultiLeg (35=AB)",
    subheadingIntroId: "options–multileg-new-order-multileg-35-ab",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Account mnemonic as agreed between broker and institution.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Unique identifier for Order as assigned by the buy-side. Uniqueness
must be guaranteed within a single trading day. Character limit is 40.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of Option Contracts ordered. Only integer values allowed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              40
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Market</li>
                <li>2 = Limit</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              44
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Price
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              The net price of the spread. This tag is required for Limit
              orders. To the customer that enters the order:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>Debit (positive) – Willing to pay</li>
                <li>Credit (negative) – Wants cash back</li>
                <li>0 (zero) – Even orders</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Side of order <br />
              Valid values:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Buy</li>
                <li>B = As Defined</li>
              </ul>
              {`The actual leg side should be in LegSide <624>`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Underlying Symbol
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. (Note: this field does not have a
              specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Specifies how long the order remains in effect.
              <br />
              Valid values: <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Day</li>
                <li>2 = At the Opening (OPG)</li>
                <li>3 = Immediate or Cancel (IOC)</li>
                <li>4 = Fill or Kill (FOK)</li>
                <li>7 = At the Close</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Execution destination as defined by institution when order is
              entered.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              109
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClientID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Firm identifier used in third party-transactions.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: MLEG
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              204
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CustomerOrFirm
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Used for options when delivering the order to an execution
              system/exchange to specify if the order is for a customer or the
              firm placing the order itself.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Customer</li>
                <li>1 = Firm</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              439
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClearingFirm<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Firm that will clear trade. Used if different from the executing
              firm.
              <br />
              Default Value: 294
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              440
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClearingAccount<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Supplemental accounting information forwarded to Clearing Firm.
              Required where multiple Clearing Accounts are used for same MPID.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              555
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              NoLegs<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`   Number of <InstrumentLeg> repeating group instances.
Upto 4 legs are supported including one Equity leg.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              →654
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegRefID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for each leg within the order, not required to
              be unique for the day. The occurrence of this Tag must be received
              in sequential order and must be the first TAG in each respective
              component block.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              →600
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegSymbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Multileg instrument's individual security's Symbol.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              →601
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegSymbolSfx
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Multileg instrument's individual security's SymbolSfx.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              →608
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegCFICode<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Multileg instrument's individual security's CFICode.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>OC = Option — Call [OPT]</li>
                <li>OP = Option — Put [OPT]</li>
                <li>ES = Equity Common Shares [CS]</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              →609
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegSecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Multileg instrument's individual security's SecurityType.
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>CS = Equity</li>
                <li>OPT = Equity Option</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              →610
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegMaturityMonthYear
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Multileg instrument's individual security's MaturityMonthYear.
              Format: YYYYMM
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              →611
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegMaturityDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Multileg instrument's individual security's MaturityDate.
Required if LegCFICode <608> is equals to OC or OP.
Format: YYYYMMDD
`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              →612
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegStrikePrice
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Multileg instrument's individual security's StrikePrice.
Required if LegCFICode <608> is equals to OC or OP.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              →623
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegRatioQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              The ratio of quantity for this individual leg relative to the
              entire multileg security.
              <br />
              Only integer values allowed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              →624
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegSide<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              The side of this individual leg (multileg security).
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Buy</li>
                <li>2 = Sell</li>
                <li>{`5 = Sell Short (valid only if LegCFICode <608> = ES)`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              →564
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegPositionEffect
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`PositionEffect for leg of a multileg.
Required if LegCFICode <608> is equals to OC or OP.
Valid values:`}
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>O = Open</li>
                <li>C = Close</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              →565
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegCoveredOrUncovered
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Multileg instrument's individual security's StrikePrice.
Required if LegCFICode <608> is equals to OC or OP.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  // Multileg Order Cancel/Replace (35=AC)
  {
    subheadingIntro: "Multileg Order Cancel/Replace (35=AC)",
    subheadingIntroId: "options–multileg-order-cancel-replace-35-ac",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Account mnemonic as agreed between broker and institution.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Unique identifier for Order as assigned by the buy-side. Uniqueness
  must be guaranteed within a single trading day. Character limit is 40.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of times the spread is available.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              40
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Market</li>
                <li>2 = Limit</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
  as assigned by the institution, used to identify the previous order in
  cancel and cancel/replace requests.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              44
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Price (Required C)
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              The net price of the spread. This tag is required for Limit
              orders. To the customer that enters the order:
              <br />
              Debit (positive) – Willing to pay
              <br />
              Credit (negative) – Wants cash back
              <br />0 (zero) – Even orders
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              47
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderCapacity (Rule80A){" "}
              <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Rule80A is also known as OrderCapacity.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>A = Agency</li>
                <li>P = Principal</li>
                <li>R = Riskless Principal</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Side of order
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Buy</li>
                <li>B = As Defined</li>
              </ul>
              {`The actual leg side should be in LegSide <624>`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Underlying Symbol
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string.(Note: this field does not have a
              specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Specifies how long the order remains in effect.
              <br />
              Valid values: <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Day</li>
                <li>1 = Good till Cancel (GTC)</li>
                <li>2 = At the Opening (OPG)</li>
                <li>3 = Immediate or Cancel (IOC)</li>
                <li>4 = Fill or Kill (FOK)</li>
                <li>7 = At the Close</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              76
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecBroker
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies executing / give-up broker. Standard NASD marketmaker
              mnemonic is preferred.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Execution destination as defined by institution when order is
              entered.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              109
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClientID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Firm identifier used in third party-transactions.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Security Type<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: MLEG
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              204
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CustomerOrFirm<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Must match the original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              439
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClearingFirm
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Firm that will clear trade. Used if different from the executing
              firm.
              <br />
              Default Value: 294
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              440
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClearingAccount<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Supplemental accounting information forwarded to Clearing Firm.
              Required where multiple Clearing Accounts are used for same MPID.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              555
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              NoLegs<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Number of <InstrumentLeg> repeating group instances.
Up to 4 legs are supported including one Equity leg.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              564
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegPositionEffect (Required C)
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`PositionEffect for leg of a multileg.
Required if LegCFICode <608> is equals to OC or OP.`}
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>O = Open</li>
                <li>C = Close</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              600
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegSymbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Multileg instrument's individual security's Symbol
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              601
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegSymbolSfx
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Multileg instrument's individual security's SymbolSfx.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              608
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegCFICode<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Multileg instrument's individual security's CFICode.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li> OC = Option — Call [OPT]</li>
                <li>OP = Option — Put [OPT]</li>
                <li> ES = Equity Common Shares [CS]</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              609
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegSecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Multileg instrument's individual security's SecurityType.
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li> CS = Equity</li>
                <li> OPT = Equity Option</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              610
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegMaturityMonthYear
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Multileg instrument's individual security's MaturityMonthYear.
              Format : YYYYMM
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              611
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegMaturityDate (Required C)
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Multileg instrument's individual security's MaturityDate.
Required if LegCFICode <608> is equals to OC or OP.
Format: YYYYMMDD`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              612
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegStrikePrice (Required C)
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Multileg instrument's individual security's StrikePrice.
Required if LegCFICode <608> is equals to OC or OP.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              623
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegRatioQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              The ratio of quantity for this individual leg relative to the
              entire multileg security.
              <br />
              Only integer values allowed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              624
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegSide<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              The side of this individual leg (multileg security).
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li> 1 = Buy</li>
                <li>2 = Sell</li>
                <li>{`5 = Sell Short (valid only if LegCFICode <608> = ES)`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              654
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegRefID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for each leg within the order, not required to
              be unique for the day. The occurrence of this Tag must be received
              in sequential order and must be the first TAG in each respective
              component block.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //Order Cancel Request (35=F)
  {
    subheadingIntro: "Order Cancel Request (35=F)",
    subheadingIntroId: "options–multileg-order-cancel-request-35-f",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Account mnemonic as agreed between broker and institution.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of times the spread is available.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
  as assigned by the institution, used to identify the previous order in
  cancel and cancel/replace requests.
  `}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side (Required O)
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text (Required O)
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. (Note: this field does not have a
              specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Security Type<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: MLEG
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              555
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              NoLegs<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              564
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegPositionEffect<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              600
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegSymbol <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              601
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegSymbolSfx <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              608
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegCFICode <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              611
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegMaturityDate <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              612
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegStrikePrice <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              623
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegRatioQty <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              624
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegSide <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              654
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegRefID <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //Execution Report (35=8)
  {
    subheadingIntro: "Execution Report (35=8)",
    subheadingIntroId: "options–multileg-execution-report-35-8",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Account mnemonic as agreed between broker and institution.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              AvgPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Average price of executions for this order weighed by trade size.
Zero if CumQty <14> is zero.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              14
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CumQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Total number of contracts/shares filled
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              17
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier of execution message
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              19
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecRefID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Reference identifier used with Cancel and Correct transaction
              types
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              20
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecTransType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies transaction type
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
                <li>1 = Cancel</li>
                <li>2 = Correct</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              30
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastMkt<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Market of execution for last fill.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              31
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Price of this fill (zero for non-fills)
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              32
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastShares<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of contracts/shares last filled.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of Contracts/shares
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              39
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdStatus<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies current status of order or chain of orders if
              cancel/replaced.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
                <li>1 = Partially filled</li>
                <li>2 = Filled</li>
                <li>3 = Done for day</li>
                <li>4 = Canceled</li>
                <li>5 = Replaced</li>
                <li>6 = Pending Cancel</li>
                <li>8 = Rejected</li>
                <li>A = Pending New</li>
                <li>E = Pending Replace</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              40
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
as assigned by the institution, used to identify the previous order in
cancel and cancel/replace requests.
`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              44
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Price
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. <br />
              (Note: this field does not have a specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              76
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Exec Broker <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies executing / give-up broker. Standard NASD market-maker
              mnemonic is preferred.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              77
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OpenClose <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>O = Open</li>
                <li>C = Close</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Execution destination as defined by institution when order is
              entered.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              150
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecType <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies current status of order or chain of orders if
              cancel/replaced.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
                <li>1 = Partial fill</li>
                <li>2 = Fill</li>
                <li>3 = Done for day</li>
                <li>4 = Canceled </li>
                <li>5 = Replaced</li>
                <li>6 = Pending Cancel</li>
                <li>8 = Rejected</li>
                <li>A = Pending New</li>
                <li>E = Pending Replace</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              151
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LeavesQty <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Quantity open for further execution. LeavesQty <151> = OrderQty
<38> - CumQty <14>
If order is no longer active i.e., the OrdStatus is Canceled <39=4>,
DoneForTheDay <39=3>, or Rejected <39=8>, then LeavesQty
<151> will be 0.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityType <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: MLEG
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              201
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              PutOrCall <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              202
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              StrikePrice <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              204
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CustomerOrFirm
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              205
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MaturityDay <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              439
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClearingFirm
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              440
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClearingAccount
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Supplemental accounting information forwarded to Clearing Firm.
              Required where multiple Clearing Accounts are used for same MPID
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              442
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MultiLegReportingType (Required C)
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {` Used to indicate what an Execution Report <8> represents (e.g.
used with multi-leg securities, such as option strategies, spreads,
etc.).`}
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>2 = Individual leg of a multi-leg security</li>
                <li>3 = Multi-leg security</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              541
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MaturityDate (Required C)
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Month, Day and Year of the maturity. Format: YYYYMMDD
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              654
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LegRefID <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for each leg within the order, not required to
              be unique for the day. The occurrence of this Tag must be received
              in sequential order and must be the first TAG in each respective
              component block.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  // Order Cancel Reject (35=9)
  {
    subheadingIntro: "Order Cancel Reject (35=9)",
    subheadingIntroId: "options–multileg-order-cancel-reject-35-9",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
as assigned by the institution, used to identify the previous order in
cancel and cancel/replace requests.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              102
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CxlRejReason
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Code to identify reason for cancel rejection.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Too late to cancel</li>
                <li>1 = Unknown order</li>
                <li>2 = Broker / Exchange Option</li>
                <li>
                  3 = Order already in Pending Cancel or Pending Replace status
                </li>
                <li>{`6 = Duplicate ClOrdID <11> received`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              434
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CxlRejResponseTo
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`  Identifies the type of request that a CancelReject <9> is in response to.`}
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>{`1 = Order Cancel Request <F>`}</li>
                <li>{`2 = Order Cancel/Replace Request <G>`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //Futures
  {
    mainHeadingStatic: "Futures",
    mainGridIdStatic: "futures",
    mainHeadingDescStatic:
      "This Section describes Application messages for Futures. Following Application messages are supported.",
  },

  // New Order MultiLeg (35=AB)
  {
    subheadingIntro: "New Order Single (35=D)",
    subheadingIntroId: "futures-new-order-multileg-35-d",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Account mnemonic as agreed between broker and institution.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Unique identifier for Order as assigned by the buy-side. Uniqueness
must be guaranteed within a single trading day. Character limit is 40.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              12
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Commission
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Commission. Note if CommType <13> is Percentage, Commission <12>
of 5% should be represented as .05`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              13
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CommType
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Per Unit (implying shares, par, currency, etc.)</li>
                <li>2 = Percentage</li>
                <li>3 = Absolute (Total monetary amount)</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Currency
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies currency used for price. Absence of this field is
              interpreted as the default for the security.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              18
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecInst
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Instructions for order handling on exchange trading floor.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Not held</li>
                <li>5 = Held</li>
                <li>M = Mid-price peg (Midprice of inside quote)</li>
                <li>N = Non-negotiable</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HandInst<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Instructions for order handling on Broker trading floor
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>
                  1 = Automated execution order, private, no Broker intervention
                </li>
                <li>
                  2 = Automated execution order, public, Broker intervention OK
                </li>
                <li>3 = Manual order, best execution</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Identifies class or source of the SecurityID <48> value. Required if
SecurityID <48> is specified.`}
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = CUSIP</li>
                <li>2 = SEDOL</li>
                <li>3 = QUIK</li>
                <li>4 = ISIN number</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of Commodities ordered. Only integer values allowed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              40
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Market</li>
                <li>2 = Limit</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              44
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Price
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Price per unit of quantity. Up to 6 decimal places supported.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              47
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Rule80A<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Rule80A is also known as OrderCapacity.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>A = Agency</li>
                <li>P = Principal</li>
                <li>R = Riskless Principal</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              48
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              CUSIP or other alternate security identifier.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Side of order <br />
              Valid values:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Buy</li>
                <li>2 = Sell</li>
              </ul>
              {`The actual leg side should be in LegSide <624>`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Ticker symbol.
              {`We do support NASDAQ CMS Split Symbology. See SymbolSfx <65> for
more details.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. (Note: this field does not have a
              specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Specifies how long the order remains in effect.
              <br />
              Valid values: <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Day</li>
                <li>1 = Good till Cancel (GTC)</li>
                <li>2 = At the Opening (OPG)</li>
                <li>3 = Immediate or Cancel (IOC)</li>
                <li>4 = Fill or Kill (FOK)</li>
                <li>5 = Good till Crossing (GTX)</li>
                <li>7 = At the Close</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              63
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SettlmntTyp
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates order settlement period. Absence of this field is
              interpreted as Regular. Regular is defined as the default
              settlement period for the particular security on the exchange of
              execution.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Regular</li>
                <li>1 = Cash</li>
                <li>2 = Next Day</li>
                <li>3 = T+2</li>
                <li>4 = T+3</li>
                <li>5 = T+4</li>
                <li>6 = Future</li>
                <li>7 = When Issued</li>
                <li>8 = Sellers Option</li>
                <li>9 = T+ 5</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              65
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SymbolSfx
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {` We follow NASDAQ CMS Suffix symbology.
Send the root prefix in Symbol <55> and CMS suffix in SymbolSfx <65>
For understanding CMS Suffix, please refer to`}{" "}
              <a href="https://www.nasdaqtrader.com/trader.aspx?id=CQSsymbolconvention">
                NasdaqSymbology
              </a>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Execution destination as defined by institution when order is
              entered.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              109
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClientID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Firm identifier used in third party-transactions.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: FUT
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  // Order Cancel / Replace Request (35=G)
  {
    subheadingIntro: "Order Cancel / Replace Request (35=G)",
    subheadingIntroId: "futures-order-cancel-replace-request-35-g",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Account mnemonic as agreed between broker and institution.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Unique identifier for Order as assigned by the buy-side. Uniqueness
  must be guaranteed within a single trading day. Character limit is 40.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Currency
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              18
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecInst<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HandInst
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of shares ordered. Only integer values allowed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              40
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Market</li>
                <li>2 = Limit</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
as assigned by the institution, used to identify the previous order in
cancel and cancel/replace requests.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              44
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Price
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Price per unit of quantity.
              <br /> Up to 6 decimal places supported.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              47
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Rule80A<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              48
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. <br />
              (Note: this field does not have a specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Specifies how long the order remains in effect.
              <br />
              Valid values: <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Day</li>
                <li>1 = Good till Cancel (GTC)</li>
                <li>2 = At the Opening (OPG)</li>
                <li>3 = Immediate or Cancel (IOC)</li>
                <li>4 = Fill or Kill (FOK)</li>
                <li>5 = Good till Crossing (GTX)</li>
                <li>7 = At the Close</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              65
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SymbolSfx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              109
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClientID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Firm identifier used in third party-transactions.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Security Type<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: FUT
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //Order Cancel Request (35=F)

  {
    subheadingIntro: "Order Cancel Request (35=F)",
    subheadingIntroId: "futures-order-cancel-request-35-f",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Account mnemonic as agreed between broker and institution.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Currency
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              18
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecInst
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HandInst<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of shares ordered. Only integer values allowed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
as assigned by the institution, used to identify the previous order in
cancel and cancel/replace requests.
  `}
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              47
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Rule80A<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              48
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. (Note: this field does not have a
              specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              65
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SymbolSfx
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              109
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClientID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Security Type<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: FUT
            </MDTypography>
          ),
        },
      ],
    },
  },

  //Execution Report (35=8)
  {
    subheadingIntro: "Execution Report (35=8)",
    subheadingIntroId: "futures-execution-report-35-8",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              AvgPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Average price of executions for this order weighed by trade size.
Zero if CumQty <14> is zero.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              14
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CumQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Cumulative quantity of shares executed for this order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              17
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier of execution message. Uniqueness must be
              guaranteed within a single trading day or the life of a multi-day
              order.
              <br />
              {`ExecID <17> is provided for the following OrdStatus <39>`}
              <ul style={{ paddingTop: "10px" }}>
                <li>{`Partially Filled <39=1>`}</li>
                <li>{`Filled <39=2>`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              19
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecRefID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Reference identifier used with Cancel <20=1> and Correct <20=2>
transaction types.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              20
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecTransType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies transaction type
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
                <li>1 = Cancel</li>
                <li>2 = Correct</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HandInst<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              29
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastCapacity<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Broker capacity in order execution
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
                <li>1 = Agent</li>
                <li>2 = Cross as agent</li>
                <li>3 = Cross as principal</li>
                <li>4 = Principal</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              30
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastMkt
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Market of execution for last fill.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              31
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Price of this fill (zero for non-fills)
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              32
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastShares<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Quantity of shares traded on this fill (zero for non-fills).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of shares ordered. Only integer values allowed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              39
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdStatus<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies current status of order or chain of orders if
              cancel/replaced.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
                <li>1 = Partially filled</li>
                <li>2 = Filled</li>
                <li>3 = Done for day</li>
                <li>4 = Canceled</li>
                <li>5 = Replaced</li>
                <li>6 = Pending Cancel</li>
                <li>8 = Rejected</li>
                <li>A = Pending New</li>
                <li>E = Pending Replace</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              40
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day) as assigned by the institution, used to identify the previous order in cancel and cancel/replace requests.
`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              44
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Price
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              47
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Rule80A<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              48
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. <br />
              (Note: this field does not have a specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              65
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SymbolSfx
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              76
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Exec Broker <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies executing / give-up broker. Standard NASD market-maker
              mnemonic is preferred.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              137
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MiscFeeAmt
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Miscellaneous fee value. Used for specifying ECNs fee.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              150
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecType <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Describes the specific ExecutionReport <35=8>`}
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
                <li>1 = Partial fill</li>
                <li>2 = Fill</li>
                <li>3 = Done for day</li>
                <li>4 = Canceled </li>
                <li>5 = Replaced</li>
                <li>6 = Pending Cancel</li>
                <li>8 = Rejected</li>
                <li>A = Pending New</li>
                <li>E = Pending Replace</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              151
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LeavesQty <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Quantity open for further execution. LeavesQty <151> = OrderQty
<38> - CumQty <14>
If order is no longer active i.e., the OrdStatus is Canceled <39=4>,
DoneForTheDay <39=3>, or Rejected <39=8>, then LeavesQty <151>
will be 0.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityType <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: FUT
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              851
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastLiquidityInd <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicator to identify whether this fill was a result of a
              liquidity provider providing or liquidity taker taking the
              liquidity. Applicable only for OrdStatus (39) of Partial or
              Filled.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Added Liquidity</li>
                <li>2 = Removed Liquidity</li>
                <li>3 = Liquidity Routed Out</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9730
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Liquidity Indicato <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Used by ECNs to pass liquidity billing code.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  // Order Cancel Reject (35=9)
  {
    subheadingIntro: "Order Cancel Reject (35=9)",
    subheadingIntroId: "futures-order-cancel-reject-35-9",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
as assigned by the institution, used to identify the previous order in
cancel and cancel/replace requests.`}
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Same as original order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. <br />
              (Note: this field does not have a specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              102
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CxlRejReason
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Code to identify reason for cancel rejection.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Too late to cancel</li>
                <li>1 = Unknown order</li>
                <li>2 = Broker / Exchange Option</li>
                <li>
                  3 = Order already in Pending Cancel or Pending Replace status
                </li>
                <li>{`6 = Duplicate ClOrdID <11> received`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              434
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CxlRejResponseTo <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {` Identifies the type of request that a CancelReject <9> is in response to.`}
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>{`1 = Order Cancel Request <F>`}</li>
                <li>{`2 = Order Cancel/Replace Request <G>`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //Mutual Funds
  {
    mainHeadingStatic: "Mutual Funds",
    mainGridIdStatic: "mutual-funds",
    mainHeadingDescStatic:
      "This Section describes Application messages for Mutual Funds. Following Application messages are supported.",
  },

  // New Order MultiLeg (35=AB)
  {
    subheadingIntro: "New Order (35=D)",
    subheadingIntroId: "mutual-funds-new-order-35-d",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Contract reference.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Currency<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Identifies currency used for price.
If ForexReq <121> is required to be applied, this currency must be
equal to the fund one or equal to the settlement currency.
`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HandInst<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Instructions for order handling on Broker trading floor
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>
                  1 = Automated execution order, private, no Broker intervention
                </li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Identifies class or source of the SecurityID <48> value. Required if
SecurityID <48> is specified.`}
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>4 = ISIN number</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of units ordered in Float Values.
              {`Note: If a Notional value is provided in CashOrderQty <152> then
OrderQty <38> should NOT be present in the New Order Single
<35=D>`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              40
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Market</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              48
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              ISIN code/identifier.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Side of order <br />
              Valid values:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Buy</li>
                <li>2 = Sell (Redemption)</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              UCIT to be purchased or sold.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. (Note: this field does not have a
              specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Specifies how long the order remains in effect.
              <br />
              Valid values: <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Good till Cancel (GTC)</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              63
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SettlmntTyp
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates order settlement period. Absence of this field is
              interpreted as Regular. Regular is defined as the default
              settlement period for the particular security on the exchange of
              execution.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Regular</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
              <br />
              Will be validated if populated and assign the following available
              date for the fund if the fund is already closed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Execution destination as defined by institution when order is
              entered.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              109
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClientID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Contract reference.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              120
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SettlCurrency<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Currency of the payment to be done.
              <br />
              {`If the Currency populated here is different than the fund one
UnderlyingCurrency <318> Forex will be applied to the operation.
If this tag is not present, the currency required to be used for the
payment is the same of the UnderlyingCurrency <318> or if this is not
present, the fund base currency.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              121
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ForexReq<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Forex requested:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>
                  Y = Apply Forex to settle in a different currency than the
                  fund one.
                </li>
                <li>
                  N = No Forex to settle in the same currency of the fund.
                </li>
                <li>If not populated no forex will be applied.</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              152
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CashOrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Tag 152 will be populated with the amount in cash to be purchased
              or sold (amount before deducting fees, commissions or taxes). See
              the{" "}
              <a href="#mutual-funds-confirmation-full-fill">
                General Considerations
              </a>{" "}
              section.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: MF
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              207
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityExchange<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Market used to help identify a security.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              318
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              UnderlyingCurrency<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Currency of the fund.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  // Order Cancel Request (35=F)
  {
    subheadingIntro: "Order Cancel Request (35=F)",
    subheadingIntroId: "mutual-funds-order-cancel-request-35-f",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Contract reference.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Currency<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Identifies currency used for price.
If ForexReq <121> is required to be applied, this currency must be
equal to the fund one or equal to the settlement currency.
`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HandInst<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Instructions for order handling on Broker trading floor
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>
                  1 = Automated execution order, private, no Broker intervention
                </li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Identifies class or source of the SecurityID <48> value. Required if
SecurityID <48> is specified.`}
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>4 = ISIN number</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of units ordered in Float Values.
              {`Note: If a Notional value is provided in CashOrderQty <152> then
OrderQty <38> should NOT be present in the New Order Single
<35=D>`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              40
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Market</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              41
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrigCIOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`ClOrdID <11> of the previous order (NOT the initial order of the day)
as assigned by the institution, used to identify the previous order in
cancel and cancel/replace requests.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              48
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              ISIN code/identifier.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Side of order <br />
              Valid values:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Buy</li>
                <li>2 = Sell (Redemption)</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Funds to be purchased or sold.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. (Note: this field does not have a
              specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Specifies how long the order remains in effect.
              <br />
              Valid values: <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Good till Cancel (GTC)</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              63
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SettlmntTyp
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates order settlement period. Absence of this field is
              interpreted as Regular. Regular is defined as the default
              settlement period for the particular security on the exchange of
              execution.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Regular</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
              <br />
              Will be validated if populated and assign the following available
              date for the fund if the fund is already closed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Execution destination as defined by institution when order is
              entered.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              109
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClientID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Contract reference.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              152
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CashOrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Tag 152 will be populated with the amount in cash to be purchased
              or sold (amount before deducting fees, commissions or taxes). See
              the{" "}
              <a href="#mutual-funds-confirmation-full-fill">
                General Considerations
              </a>{" "}
              section.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: MF
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              207
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityExchange<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Market used to help identify a security.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //Status Report (35=8)
  {
    subheadingIntro: "Status Report (35=8)",
    subheadingIntroId: "mutual-funds-status-report-35-8",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              AvgPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Average price of executions for this order weighed by trade size.
Zero if CumQty <14> is zero.
`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              14
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CumQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Cumulative quantity of shares executed for this order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Currency<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Identifies currency used for price.
  If ForexReq <121> is required to be applied, this currency must be
  equal to the fund one or equal to the settlement currency.
  `}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              17
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier of execution message. Uniqueness must be
              guaranteed within a single trading day or the life of a multi-day
              order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              20
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecTransType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies transaction type
              <br />
              Valid values:
              <br />3 = Status
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Identifies class or source of the SecurityID <48> value. Required if
  SecurityID <48> is specified.`}
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>4 = ISIN number</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              31
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Price of this fill (zero for non-fills).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              32
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastShares<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Quantity of Funds traded on this fill (zero for non-fills).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              39
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdStatus<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies current status of order or chain of orders if
              cancel/replaced.
              <br />
              Valid values:
              <br />0 = New
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              48
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              ISIN code/identifier.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Side of order <br />
              Valid values:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Buy</li>
                <li>2 = Sell (Redemption)</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Funds to be purchased or sold.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. (Note: this field does not have a
              specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Specifies how long the order remains in effect.
              <br />
              Valid values: <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Good till Cancel (GTC)</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
              <br />
              Will be validated if populated and assign the following available
              date for the fund if the fund is already closed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Execution destination as defined by institution when order is
              entered.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              120
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SettlCurrency<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Currency of the payment to be done.
              <br />
              {`If the Currency populated here is different than the fund one
  UnderlyingCurrency <318> Forex will be applied to the operation.
  If this tag is not present, the currency required to be used for the
  payment is the same of the UnderlyingCurrency <318> or if this is not
  present, the fund base currency.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              150
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Describes the specific ExecutionReport <35=8>`}
              <br />
              Valid values:
              <br />0 = New
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              151
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Leaves Qty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Quantity open for further execution. LeavesQty <151> = OrderQty
<38> - CumQty <14>`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: MF
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              207
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityExchange<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Market used to help identify a security.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //Cancel Status Report (35=8)

  {
    subheadingIntro: "Cancel Status Report (35=8)",
    subheadingIntroId: "mutual-funds-cancel-status-report-35-8",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              AvgPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Average price of executions for this order weighed by trade size.
  Zero if CumQty <14> is zero.
  `}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              14
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CumQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Cumulative quantity of shares executed for this order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Currency<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Identifies currency used for price.
    If ForexReq <121> is required to be applied, this currency must be
    equal to the fund one or equal to the settlement currency.
    `}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              17
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier of execution message. Uniqueness must be
              guaranteed within a single trading day or the life of a multi-day
              order
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              20
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecTransType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies transaction type
              <br />
              Valid values:
              <br />3 = Status
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Identifies class or source of the SecurityID <48> value. Required if
    SecurityID <48> is specified.`}
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>4 = ISIN number</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              31
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Price of this fill (zero for non-fills).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              32
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastShares<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Quantity of Funds traded on this fill (zero for non-fills).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side. Uniqueness
              must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              39
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdStatus<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies current status of order or chain of orders if
              cancel/replaced.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>4 = Canceled</li>
                <li>8 = Rejected</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              48
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              ISIN code/identifier.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Side of order <br />
              Valid values:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Buy</li>
                <li>2 = Sell (Redemption)</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Funds to be purchased or sold.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. (Note: this field does not have a
              specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Specifies how long the order remains in effect.
              <br />
              Valid values: <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Good till Cancel (GTC)</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
              <br />
              Will be validated if populated and assign the following available
              date for the fund if the fund is already closed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Execution destination as defined by institution when order is
              entered.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              120
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SettlCurrency<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Currency of the payment to be done.
              <br />
              {`If the Currency populated here is different than the fund one
    UnderlyingCurrency <318> Forex will be applied to the operation.
    If this tag is not present, the currency required to be used for the
    payment is the same of the UnderlyingCurrency <318> or if this is not
    present, the fund base currency.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              150
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Describes the specific ExecutionReport <35=8>`}
              <br />
              Valid values:
              <br />0 = New
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              151
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Leaves Qty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Quantity open for further execution. LeavesQty <151> = OrderQty
  <38> - CumQty <14>`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: MF
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              207
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityExchange<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Market used to help identify a security.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //Confirmation (Full Fill)
  {
    subheadingIntro: "Confirmation (Full Fill)",
    subheadingIntroId: "mutual-funds-confirmation-full-fill",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Contract reference.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              AvgPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Average price of executions for this order weighed by trade size.
Zero if CumQty <14> is zero.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              12
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Commission
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Fund commission applied
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              14
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CumQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Cumulative quantity of shares/contracts executed for this order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Currency<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies currency used for price.
              {`If ForexReq <121> is required to be applied, this currency must be
equal to the fund one or equal to the settlement currency.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              17
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier of execution message. Uniqueness must be
              guaranteed within a single trading day or the life of a multi-day
              order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              20
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecTransType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies transaction type
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Identifies class or source of the SecurityID <48> value. Required if
SecurityID <48> is specified.`}
              <br />
              Valid values:
              <br />4 = ISIN number
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              31
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Price of this fill (zero for non-fills).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              32
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastShares<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Quantity of shares traded on this fill (zero for non-fills).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side.
              <br /> Uniqueness must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              39
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdStatus<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies current status of order or chain of orders if
              cancel/replaced.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>2 = Filled</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              40
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <br />1 = Market
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              44
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Price
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Price per Funds
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              48
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              ISIN code/identifier
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Side of order
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Buy (Subscription)</li>
                <li>2 = Sell (Redemption)</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Funds to be purchased or sold.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. <br />
              (Note: this field does not have a specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Specifies how long the order remains in effect.
              <br />
              Valid values:
              <br />1 = Good till Cancel (GTC)
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC. (Universal Time
              Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              63
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SettlmntTyp
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates order settlement period. Absence of this field is
              interpreted as Regular. Regular is defined as the default
              settlement period for the particular security on the exchange of
              execution.
              <br />
              Valid values:
              <br />0 = Regular
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              64
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              FutSettDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Settlement date
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
              <br />
              Will be validated if populated and assign the following available
              date for the fund if the fund is already closed.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              100
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExDestination <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Execution destination as defined by institution when order is
              entered.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              119
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SettlCurrAmt <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Total amount due expressed in settlement currency (includes the
              effect of the forex transaction)
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              120
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SettlCurrency
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Currency of the payment to be done.
              {`If the Currency populated here is different than the fund one
UnderlyingCurrency <318> Forex will be applied to the operation.
If this tag is not present, the currency required to be used for the
payment is the same of the UnderlyingCurrency <318> or if this is not
present, the fund base currency.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              150
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecType <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Describes the specific ExecutionReport <35=8>`}
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              151
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Leaves Qty <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Quantity open for further execution. LeavesQty <151> = OrderQty
    <38> - CumQty <14>`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              155
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SettlCurrFxRate<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Foreign exchange rate used to compute SettlCurrAmt <119> from
Currency <15> to SettlCurrency <120>`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              156
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SettlCurrFxRateCalc<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Specifies whether or not SettlCurrFxRate <155> should be multiplied
or divided.`}
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>M = Multiply</li>
                <li>D = Divide</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              193
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              FutSettDate2<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Payment date. Settlement date related to the payment
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              381
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SettlCurrAmt<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Gross amount confirmed (amount before deducting fees, commissions
              or taxes) See the{" "}
              <a href="#mutual-funds-confirmation-full-fill">
                General Considerations
              </a>{" "}
              section.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5675
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TaxRate<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Tax rate applied (if any) – Only provided for Spanish client
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              7353
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TaxAmt<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Amount of tax applied – Only provided for Spanish client
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityType <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security. Default value: CS
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              207
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityExchange <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Market used to help identify a security.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //General Considerations
  {
    mainHeadingStatic: "General Considerations",
    mainGridIdStatic: "mutual-funds-general-considerations",
    mainHeadingDescStatic:
      "Trades should always be in gross amount, so the amount requested in subscriptions and redemptions will be the amount requested to the fund. Net subscriptions or redemptions are not available.",
    mainHeadingDescOne:
      "For subscription and redemption confirmations please consider the following rule for the gross amount field (tag 381):",
    list: {
      a: "Subscriptions: gross amount = (Units * Price) + Fees",
      b: "Redemptions: gross amount = (Units * Price)",
    },
    mainHeadingDescthree: `In the confirmation messages you can find the number of units, price applied, and fees applied as well as the
    settlement amount already calculated in the payment currency. So, you can calculate the amounts you may
    need.`,
    examp: "Example:",
    list: [
      {
        a: "Subscriptions: gross amount = (Units * Price) + Fees",
      },
      {
        a: "Redemptions: gross amount = (Units * Price)",
      },
    ],
    exampleOne:
      "Subscription in amount for 100EUR with price = 10 and a fund fee of 5EUR",
    listTwo: [
      {
        b: "Gross amount confirmed = 100EUR",
      },
      {
        b: "Price applied = 10",
      },
      {
        b: "Fee applied = 5",
      },
      {
        b: "Units confirmed = 9,5 ( [100 – 5]/10 )",
      },
      {
        b: "Settlement amount = 100EUR",
      },
    ],
    exampleTwo:
      "Redemption in amount for 100EUR with price = 10 and a fund fee of 5EUR",
    listThree: [
      {
        c: "Gross amount confirmed = 100EUR",
      },
      {
        c: "Price applied = 10",
      },
      {
        c: "Fee applied = 5",
      },
      {
        c: "Units confirmed = 10 (100/10)",
      },
      {
        c: "Settlement amount = 95EUR (100 - 5)",
      },
    ],
    exampleThree:
      "To adapt the messages, the following requirements are needed:",
    listFour: [
      {
        d: "The reference of the messages must be unique.",
      },
      {
        d: "The reference of the orders must be unique and a maximum of 17 positions.",
      },
      {
        d: "The contract code will have a maximum of 20 positions.",
      },
      {
        d: "The maximum number of decimal for amounts are 2.",
      },
      {
        d: "The maximum number for decimal in shares are 6.",
      },
    ],
  },

  //Dropcopies (NOE’s) and Allocations
  {
    mainHeadingStatic: "Dropcopies (NOE’s) and Allocations",
    mainGridIdStatic: "dropcopies-noes-and-allocations",
    mainHeadingDescStatic:
      "This Section describes Application messages for receiving Dropcopies of “Notice of Executions” (NOE messages) and Allocation Dropcopy messages. Following Application messages are supported.",
  },

  //Execution Report (35=8)
  {
    subheadingIntro: "Execution Report (35=8)",
    subheadingIntroId: "dropcopies-execution-report-35-8",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Account mnemonic as agreed between broker and institution.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              AvgPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Average price of executions for this order weighed by trade size.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by the buy-side.
              Uniqueness must be guaranteed within a single trading day.
              Character limit is 40.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              12
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Commission
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Commission. Note if CommType <13> is Percentage, Commission
<12> of 5% should be represented as .05`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              13
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CommType
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Per Unit (implying shares, par, currency, etc.)</li>
                <li>2 = Percentage</li>
                <li>3 = Absolute (Total monetary amount)</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              14
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CumQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Cumulative quantity of shares executed for this order.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              17
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Unique identifier of execution message. Uniqueness must be guaranteed within a single trading day or the life of a multi-day order.

ExecID <17> is provided for the following OrdStatus <39>`}
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>{`Partially Filled <39=1>`}</li>

                <li>{`Filled <39=2>`}</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              18
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecInst
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Instructions for order handling on exchange trading floor.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Not held</li>
                <li>5 = Held</li>
                <li>M = Mid-price peg (Midprice of inside quote)</li>
                <li>N = Non-negotiable</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              19
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecRefID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Reference identifier used with Cancel <20=1> and Correct <20=2> transaction types.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              20
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecTransType
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Instructions for order handling on exchange trading floor.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
                <li>1 = Cancel</li>
                <li>2 = Correct</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              HandInst
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Instructions for order handling on Broker trading floor
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>
                  1 = Automated execution order, private, no Broker intervention
                </li>
                <li>
                  2 = Automated execution order, public, Broker intervention OK
                </li>
                <li>3 = Manual order, best execution</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityIDSource
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Identifies class or source of the SecurityID <48> value. Required if SecurityID <48> is specified.`}
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = CUSIP</li>
                <li>2 = SEDOL</li>
                <li>3 = QUIK</li>
                <li>4 = ISIN number</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              29
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Last Capacity
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Broker capacity in order execution
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Agent</li>
                <li>2 = Cross as agent</li>
                <li>3 = Cross as principal</li>
                <li>4 = Principal</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              30
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastMkt<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Market of execution for last fill.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              31
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Price of this fill (zero for non-fills).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              32
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastShares<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Quantity (e.g. shares) bought/sold on this (last) fill.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side.
              <br /> Uniqueness must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              38
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of shares ordered.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              39
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdStatus<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies current status of order or chain of orders if
              cancel/replaced.
              <br />
              Valid values:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Partially filled</li>
                <li>2 = Filled</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              40
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrdType
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Market</li>
                <li>2 = Limit</li>
                <li>3 = Stop</li>
                <li>4 = Stop limit</li>
                <li>P = Pegged</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              44
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Price
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              (Up to 6 decimal places supported)
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              47
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Ord Capacity
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Rule80A is also known as OrderCapacity.
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>A = Agency</li>
                <li>P = Principal</li>
                <li>R = Riskless Principal</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              48
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Security identifier value of SecurityIDSource (22) type (e.g.
              CUSIP, SEDOL, ISIN, etc.) Requires SecurityIDSource.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Side of order
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Buy</li>
                <li>2 = Sell</li>
                <li>5 = Sell short</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Ticker symbol.
              {`We do support NASDAQ CMS Split Symbology. See SymbolSfx <65>
for more details.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              58
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Text
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Free format text string. <br />
              (Note: this field does not have a specified maximum length).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              60
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactTime <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Time of execution/order creation expressed in UTC.
              <br />
              (Universal Time Coordinated, also known as 'GMT')
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              65
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SymbolSfx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`We follow NASDAQ CMS Suffix symbology.
Send the root prefix in Symbol <55> and CMS suffix in SymbolSfx<65>
For understanding CMS Suffix, please refer to`}{" "}
              <a href="https://www.nasdaqtrader.com/trader.aspx?id=CQSsymbolconvention">
                NasdaqSymbology
              </a>
              .
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              76
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Exec Broker <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies executing / give-up broker. Standard NASD market-maker
              mnemonic is preferred.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              59
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TimeInForce <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Specifies how long the order remains in effect.
              <br />
              Valid values:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Day</li>
                <li>1 = Good till Cancel (GTC)</li>
                <li>2 = At the Opening (OPG)</li>
                <li>3 = Immediate or Cancel (IOC)</li>
                <li>4 = Fill or Kill (FOK)</li>
                <li>5 = Good till Crossing (GTX)</li>
                <li>7 = At the Close</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              137
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MiscFeeAmt
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Miscellaneous fee value. Used for specifying ECN’s fee.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              150
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Partially filled</li>
                <li>2 = Filled</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              151
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ExecType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              The amount of shares open for further execution. (do not use it in
              decision making for Realtime execution streaming, it’s a static
              summary).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              200
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MaturityMonthYear
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`  Month and Year of the maturity for SecurityType <167>=OPT.
Required if MaturityDay <205> is specified.
`}
              Format: YYYYMM
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              201
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              PutOrCall
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Indicates whether an Option is for a put or call for SecurityType
<167>=OPT.`}
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Put</li>
                <li>1 = Call</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              202
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              StrikePrice
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Strike Price for an Option.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              203
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CoveredOrUncovered
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Used for SecurityType <167>=OPT.`}
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Covered</li>
                <li>1 = Uncovered</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              204
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CustomerOrFirm
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Used for SecurityType <167>=OPT when delivering the order to an
execution system/exchange to specify if the order is for a customer
or the firm placing the order itself.`}
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Customer</li>
                <li>1 = Firm</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              205
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MaturityDay
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Day of month used in conjunction with MaturityMonthYear <200> to
specify the maturity date for SecurityType <167>=OPT.`}
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1-31</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              439
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClearingFirm
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              For option orders, this field can be pre-configured and can be per
              order basis too.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              851
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              LastLiquidityInd<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicator to identify whether this fill was a result of a
              liquidity provider providing or liquidity taker taking the
              liquidity. Applicable only for OrdStatus (39) of Partial or
              Filled.
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Added Liquidity</li>
                <li>2 = Removed Liquidity</li>
                <li>3 = Liquidity Routed Out</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9730
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Liquidity Indicator<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Used by ECNs to pass liquidity billing code.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  //Allocation Message
  {
    subheadingIntro: "Allocation Message",
    subheadingIntroId: "dropcopies-allocation-message",
    sessionTable: {
      columns: [...regularHeader],
      rows: [
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Header<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Account mnemonic as agreed between broker and institution.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              AvgPx<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Average price of executions for this order weighed by trade size.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ClOrdID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Set to "MANUAL"
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              12
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Commission
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Commission. Note if CommType <13> is Percentage, Commission
<12> of 5% should be represented as .05`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              13
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CommType
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Per Unit (implying shares, par, currency, etc.)</li>
                <li>2 = Percentage</li>
                <li>3 = Absolute (Total monetary amount)</li>
              </ul>
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              37
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              OrderID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique identifier for Order as assigned by sell-side.
              <br /> Uniqueness must be guaranteed within a single trading day.
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              53
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Shares<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Whole number, max 6 digits
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              54
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Side <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Side of order
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1 = Buy</li>
                <li>2 = Sell</li>
                <li>5 = Sell short</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              55
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Symbol <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Ticker symbol.
              {`We do support NASDAQ CMS Split Symbology. See SymbolSfx <65>
for more details.`}
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              64
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SettlDate
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Specific date of trade settlement (Settlement Date) in YYYYMMDD
              format.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              70
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              AllocID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Unique ID of allocation as assigned by the Institution.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              71
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              AllocTransType <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Identifies allocation transaction type Valid values:
              <br />
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = New</li>
                <li>1 = Replace</li>
                <li>2 = Cancel</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              72
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              RefAllocID
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Reference identifier to be used with Replace, Cancel, and Calculated AllocTransType <71> messages.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              73
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              NoOrders<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates number of orders to be combined for average pricing and
              allocation. Default value is 1.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              75
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TradeDate <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates date of trade referenced in this message in YYYYMMDD
              format. Absence of this field indicates current day (expressed in
              local time at place of trade).
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              78
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              NoAllocs <span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {` Number of repeating AllocAccount <79>/AllocPrice <366> entries. Default value is 1.`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              79
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              AllocAccount<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Sub-account mnemonic
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              80
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              AllocShares<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Number of shares to be allocated to specific sub-account
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              167
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              SecurityType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Indicates type of security.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              200
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MaturityMonthYear
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`  Month and Year of the maturity for SecurityType <167>=OPT.
Required if MaturityDay <205> is specified.
Format: YYYYMM`}
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              201
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              PutOrCall
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Indicates whether an Option is for a put or call for SecurityType <167>=OPT.
Valid values:`}
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Put</li>
                <li>1 = Call</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              202
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              StrikePrice
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              Strike Price for an Option.
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              203
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CoveredOrUncovered
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Used for SecurityType <167>=OPT.`}
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Covered</li>
                <li>1 = Uncovered</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              204
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CustomerOrFirm
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Used for SecurityType <167>=OPT when delivering the order to an
execution system/exchange to specify if the order is for a customer
or the firm placing the order itself.`}
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>0 = Customer</li>
                <li>1 = Firm</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              205
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              MaturityDay
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              {`Day of month used in conjunction with MaturityMonthYear <200> to
specify the maturity date for SecurityType <167>=OPT.`}
              <br />
              Valid values:
              <ul style={{ listStyle: "none", paddingTop: "10px" }}>
                <li>1-31</li>
              </ul>
            </MDTypography>
          ),
        },

        {
          tag: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Standard Trailer<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          comments: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            ></MDTypography>
          ),
        },
      ],
    },
  },

  // Legal Notice
  {
    mainHeadingStatic: "Legal Notices",
    mainGridIdStatic: "legal-notices",
    mainHeadingDescStatic: `This document contains material proprietary and confidential to Gato Systems.
    No part of the document may be distributed or reproduced in any form without the express written permission from Gato Systems.`,
    mainHeadingDescStaticTwo: `This document is not a recommendation to engage in any action, does not constitute or form any part of any offer to sell
    or issue and is not a solicitation of any offer to purchase any financial instrument, nor shall it or any part of it nor the fact
    of its distribution form the basis of, or be relied on in connection with any contract or investment decision.
    The information contained in this document has been obtained from sources believed to be reliable, but there is no
    guarantee of the accuracy, completeness, or suitability for any particular purpose of such information or that such
    information has been independently verified by Gato Systems.`,
  },
];

export default fixApiData;
